'use client';

import { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence, useInView, useReducedMotion } from 'motion/react';
import type { Swiper as SwiperType } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { SiteFooter } from './SiteFooter';
import {
  getLandingPageData,
  type LandingPageBlogPreviewPost,
  type LandingPageCTA,
  type LandingPageContrasteRow,
  type LandingPageDiferencialCard,
  type LandingPageDiferenciais,
  type LandingPageHeroHighlight,
  type LandingPageHeroSlide,
  type LandingPageInstrutor,
  type LandingPageObjecao,
  type LandingPagePlano,
  type LandingPageStats,
  type LandingPageStatsBar,
  type LandingPageTrilha,
} from '@/lib/landing/mapping';
import {
  Sparkles, Heart, Flame, Lock, Users, Star,
  Circle, Zap, Droplet, Wind, Moon, Sun,
  ArrowRight, Check, Menu, X, Play,
  LayoutList,
  ChevronRight,
} from 'lucide-react';
import {
  IconCoinOff, IconEyeOff, IconBulb, IconMoodSad,
  IconClock, IconUserHeart, IconCircleCheck,
  IconCoin, IconBook, IconUserCheck, IconSitemap,
} from '@tabler/icons-react';

interface LandingPageProps {
  onIniciarQuiz: () => void;
}

const HEADING = { fontFamily: 'var(--font-heading)' };
const BODY = { fontFamily: 'var(--font-body)' };

/* ── DATA ─────────────────────────────────────────────────── */

const fallbackTrilhas = [
  { id: "prazer_feminino", num: "01", nome: "Prazer Feminino", icon: Sparkles, cor: "#FF006E", gradiente: "from-pink-500 via-rose-500 to-pink-600", descricao: "Anatomia real, zonas erógenas, orgasmo e comunicação com o parceiro. Como a mulher pode se colocar em primeiro lugar — sem mitos, sem culpa.", imagem: "/images/quiz-trilhas/prazer-feminino.jpeg", imagemAlt: "Imagem editorial da trilha Prazer Feminino" },
  { id: "posicoes", num: "02", nome: "Posições Sexuais", icon: Circle, cor: "#FB5607", gradiente: "from-orange-600 via-red-500 to-rose-600", descricao: "Posições além do básico: variações, adaptações por biotipo, técnicas para intensificar o prazer — com demonstrações claras e objetivas.", imagem: "/images/quiz-trilhas/posicoes.jpeg", imagemAlt: "Imagem editorial da trilha Posições Sexuais" },
  { id: "fetiches", num: "03", nome: "Fetiches & Fantasias", icon: Flame, cor: "#FB5607", gradiente: "from-orange-500 via-red-500 to-pink-600", descricao: "Fetiches abordados sem tabu: o que são, como explorar com segurança, como conversar com o parceiro e como incorporá-los à vida a dois com leveza.", imagem: "/images/quiz-trilhas/fetiches.jpeg", imagemAlt: "Imagem editorial da trilha Fetiches e Fantasias" },
  { id: "relacionamentos_abertos", num: "04", nome: "Relacionamentos Abertos", icon: Users, cor: "#FF006E", gradiente: "from-pink-600 via-fuchsia-500 to-purple-600", descricao: "Swing, relacionamento aberto, não-monogamia consensual — entenda os modelos, seus limites, regras e como casais navegam com maturidade e respeito.", imagem: "/images/quiz-trilhas/vida-liberal.jpeg", imagemAlt: "Imagem editorial da trilha Relacionamentos Abertos" },
  { id: "seducao", num: "05", nome: "Sedução", icon: Moon, cor: "#7209B7", gradiente: "from-violet-600 via-purple-600 to-fuchsia-600", descricao: "A arte da sedução na vida real: linguagem corporal, gatilhos de atração e como manter o desejo aceso em relacionamentos de longo prazo.", imagem: "/images/quiz-trilhas/seducao.jpeg", imagemAlt: "Imagem editorial da trilha Sedução" },
  { id: "sexo_anal", num: "06", nome: "Sexo Anal", icon: Droplet, cor: "#7209B7", gradiente: "from-purple-600 via-fuchsia-600 to-pink-600", descricao: "Guia completo para quem quer explorar o sexo anal: preparação, higiene, técnicas, comunicação e progressão natural — sem dor, sem pressa.", imagem: "/images/quiz-trilhas/sexo-anal.jpeg", imagemAlt: "Imagem editorial da trilha Sexo Anal" },
  { id: "ejaculacao", num: "07", nome: "Ejaculação Precoce", icon: Wind, cor: "#3A0CA3", gradiente: "from-indigo-700 via-purple-600 to-violet-600", descricao: "Técnicas comprovadas para controle e duração: respiração, exercícios de assoalho pélvico e práticas que transformam a experiência sem uso de remédios.", imagem: "/images/quiz-trilhas/ejaculacao.jpeg", imagemAlt: "Imagem editorial da trilha Ejaculação Precoce" },
  { id: "podolatria", num: "08", nome: "Podolatria", icon: Sun, cor: "#F72585", gradiente: "from-pink-500 via-rose-500 to-red-500", descricao: "Pés como zona de prazer: história, prática, higiene, como abordar o tema com o parceiro e técnicas para quem quer explorar esse universo sem julgamento.", imagem: "/images/quiz-trilhas/podolatria.jpeg", imagemAlt: "Imagem editorial da trilha Podolatria" },
  { id: "brinquedos", num: "09", nome: "Brinquedos Eróticos", icon: Star, cor: "#F72585", gradiente: "from-rose-500 via-pink-600 to-fuchsia-600", descricao: "Vibrador, plug, anel, cinta — o guia definitivo sobre brinquedos: como escolher, usar solo ou a dois, higienizar e tirar o máximo de cada experiência.", imagem: "/images/quiz-trilhas/brinquedos.jpeg", imagemAlt: "Imagem editorial da trilha Brinquedos Eróticos" },
  { id: "massagens", num: "10", nome: "Massagens Sensuais", icon: Heart, cor: "#B5179E", gradiente: "from-fuchsia-500 via-purple-500 to-pink-500", descricao: "Toque sensual, massagem tântrica, pontos de prazer: como usar as mãos para criar conexão real e transformar uma massagem em uma experiência de presença.", imagem: "/images/quiz-trilhas/massagens.jpeg", imagemAlt: "Imagem editorial da trilha Massagens Sensuais" },
  { id: "gravidez", num: "11", nome: "Sexo na Gravidez", icon: Heart, cor: "#FF006E", gradiente: "from-rose-500 via-pink-500 to-fuchsia-500", descricao: "Sexo na gravidez: o que muda, o que continua e como manter o prazer e a intimidade com segurança em cada trimestre. Sem mitos, sem exageros.", imagem: "/images/quiz-trilhas/gravidez.jpeg", imagemAlt: "Imagem editorial da trilha Sexo na Gravidez" },
  { id: "bdsm", num: "12", nome: "BDSM", icon: Lock, cor: "#3A0CA3", gradiente: "from-indigo-600 via-violet-600 to-purple-700", descricao: "BDSM desmistificado: dominação, submissão, bondage e disciplina com seriedade, segurança e respeito pelo consentimento — do iniciante ao experiente.", imagem: "/images/quiz-trilhas/bdsm.jpeg", imagemAlt: "Imagem editorial da trilha BDSM" },
  { id: "prazer_masculino", num: "13", nome: "Prazer Masculino", icon: Zap, cor: "#8338EC", gradiente: "from-purple-500 via-violet-500 to-purple-600", descricao: "Prazer masculino além da ereção: ponto G masculino, técnicas de estimulação e como maximizar a experiência individual e a dois sem o peso da performance.", imagem: "/images/quiz-trilhas/prazer-masculino.jpeg", imagemAlt: "Imagem editorial da trilha Prazer Masculino" },
] satisfies LandingPageTrilha[];

const trilhaStats = [
  { num: '+120', label: 'vídeos no total' },
  { num: '13', label: 'trilhas disponíveis' },
];

const fallbackHeroHighlights = [
  { num: '13', label: 'Trilhas temáticas' },
  { num: '+120', label: 'Aulas disponíveis' },
  { num: 'R$14,90', label: 'Acesso a partir de R$14,90' },
] satisfies LandingPageHeroHighlight[];

const fallbackHeroSlides = [
  {
    url: "/images/landing/hero-1.jpeg",
    alt: "Ambiente intimista com fotografia editorial da RATI",
    overlay: "from-pink-900/40 via-black/20 to-purple-900/30",
  },
  {
    url: "/images/landing/hero-2.jpeg",
    alt: "Fotografia editorial escura com atmosfera sensual",
    overlay: "from-purple-900/40 via-black/20 to-pink-900/30",
  },
  {
    url: "/images/landing/hero-3.jpeg",
    alt: "Retrato editorial usado na abertura da landing da RATI",
    overlay: "from-black/50 via-purple-900/20 to-pink-900/30",
  },
] satisfies LandingPageHeroSlide[];

const fallbackAssinaturaPlanos = [
  { nome: "7 Dias", tagline: "Experimente sem compromisso", preco: "14", centavos: "90", periodo: "acesso por 7 dias · sem renovação", popular: false, recursos: ["Acesso completo por 7 dias", "Todas as 13 trilhas", "+120 aulas disponíveis", "Cobrança discreta na fatura"], cta: "Começar agora", link: "" },
  { nome: "Mensal", tagline: "No seu ritmo, sem pressão", preco: "24", centavos: "90", periodo: "por mês · cancele quando quiser", popular: false, recursos: ["Acesso mensal ilimitado", "Novas aulas incluídas", "Cancele a qualquer momento", "Cobrança discreta na fatura"], cta: "Assinar mensal", link: "" },
  { nome: "Anual", tagline: "Melhor valor", preco: "119", centavos: "40", periodo: "12 meses · menos de R$10 por mês", popular: true, recursos: ["12 meses de acesso total", "Todas as trilhas + novidades", "50% de economia real", "Cobrança discreta na fatura"], cta: "Assinar com 50% de desconto", link: "" },
] satisfies LandingPagePlano[];

const fallbackContrasteRows = [
  {
    tema: "Preço",
    problema: "R$97 a R$197 por um único tema — e mais se quiser o próximo.",
    solucao: "R$24,90/mês · uma assinatura dá acesso às 13 trilhas e a todo conteúdo novo.",
  },
  {
    tema: "Conteúdo",
    problema: "Metáforas, eufemismos, rodeios. Você assiste uma hora e sai sem uma técnica.",
    solucao: "Linguagem direta, técnicas que você aplica hoje. Sem interpretação necessária.",
  },
  {
    tema: "Instrutor",
    problema: "Credencial bonita, zero vivência. Teoria acadêmica que não funciona na prática.",
    solucao: "Praticantes que viveram o que ensinam — não teóricos que decidiram cobrar por isso.",
  },
  {
    tema: "Organização",
    problema: "Catálogo sem trilha. Você assina, abre a plataforma e não sabe por onde começar.",
    solucao: "13 trilhas com progressão lógica. Do básico ao avançado, você sabe o próximo passo.",
  },
] satisfies LandingPageContrasteRow[];

const contrasteIcons = [IconCoin, IconBook, IconUserCheck, IconSitemap];

const diferenciaisCards = [
  { icon: Zap, titulo: "Direto ao ponto", texto: "Sem metáforas, sem rodeios. Você aprende técnicas reais, com linguagem clara — sem precisar interpretar entrelinhas." },
  { icon: Lock, titulo: "Privacidade total", texto: "Cobrança discreta na fatura, acesso anônimo. Ninguém precisa saber — a não ser você." },
  { icon: Star, titulo: "Instrutores com vivência real", texto: "Especialistas com formação e prática. Não contratamos quem só leu sobre o assunto." },
  { icon: Flame, titulo: "Tudo em um só lugar", texto: "Uma assinatura, 13 trilhas, +120 aulas. Novo conteúdo adicionado sem custo extra." },
 ] satisfies LandingPageDiferencialCard[];

const fallbackObjecoes = [
  {
    Icon: IconCoinOff,
    problema: "Curso de sexualidade é caro. Vou pagar alto para ter acesso a um único conteúdo limitado.",
    solucao: "Uma assinatura dá acesso a tudo: +120 aulas em 13 trilhas, mais todo conteúdo novo lançado. A partir de R$14,90 — menos que uma pizza.",
  },
  {
    Icon: IconEyeOff,
    problema: "Tenho vergonha de assinar. E se alguém descobrir? A cobrança vai aparecer de forma estranha na fatura?",
    solucao: "A cobrança aparece na fatura como uma empresa genérica — sem logos, sem nomes sugestivos. Ninguém saberá o que é. Prometemos.",
  },
  {
    Icon: IconBulb,
    problema: "Provavelmente é tudo aquela coisa básica que já sei. Não vejo como vou aprender algo novo.",
    solucao: "Cada trilha tem níveis — do fundamentos ao avançado. Se você já sabe o básico, vai em frente. Nossos instrutores ensinam o que aprenderam na prática, não na teoria.",
  },
  {
    Icon: IconMoodSad,
    problema: "Já tentei outro curso e foi uma decepção — conteúdo superficial, muita teoria e pouca prática.",
    solucao: "Nossa garantia é simples: 7 dias para explorar tudo. Se não for o que esperava, devolvemos 100% — sem perguntas, sem burocracia. Você não tem nada a perder.",
  },
  {
    Icon: IconClock,
    problema: "Não tenho tempo para ficar assistindo aula — sou ocupado, trabalho, tenho família.",
    solucao: "Aulas de 5 a 15 minutos. No celular, no seu ritmo, quando quiser. Sem prazo para terminar — o acesso é seu enquanto assinar.",
  },
  {
    Icon: IconUserHeart,
    problema: "Tenho mais de 45 anos — isso é pra jovem. Não vou me identificar com o conteúdo.",
    solucao: "Nossa maior faixa de assinantes tem entre 35 e 55 anos. Temos trilhas específicas para quem está num relacionamento longo, atravessando mudanças hormonais ou simplesmente redescubrindo o prazer sem culpa.",
  },
] satisfies LandingPageObjecao[];

const fallbackInstrutores = [
  {
    nome: "Orange Girl",
    especialidade: "Sexualidade Feminina",
    foto: "/images/instrutores/orange-girl.jpeg",
    bio: "Dominatrix e criadora de conteúdo que conhece o prazer feminino de dentro para fora — fetiches, limites e tudo que fica entre eles. Não aprendeu em livro. Viveu, experimentou e agora ensina sem rodeios o que realmente funciona.",
    badge: "Sexualidade Feminina · Fetiches",
    trilhas: ["Prazer Feminino", "Fetiches & Fantasias", "BDSM"],
    aulas: [
      { titulo: "O prazer feminino sem filtro", duracao: "21 min" },
      { titulo: "Fetiches: como abordar o parceiro", duracao: "18 min" },
      { titulo: "Dominação e prazer feminino", duracao: "24 min" },
    ],
    citacao: "Você não precisa de permissão para sentir prazer. Só precisa de informação.",
    gradiente: "from-pink-500 to-rose-600",
  },
  {
    nome: "Mario",
    especialidade: "Prazer Masculino",
    foto: "/images/instrutores/mario.jpeg",
    bio: "Ator e criador de conteúdo que foi fundo no universo tântrico para entender o prazer masculino além do básico. Compartilha o que testou na prática — sexo, energia e conexão sem o peso da performance.",
    badge: "Prazer Masculino · Tântrico",
    trilhas: ["Prazer Masculino", "Ejaculação Precoce", "Massagens Sensuais"],
    aulas: [
      { titulo: "Controle sem ansiedade", duracao: "22 min" },
      { titulo: "Ponto G masculino na prática", duracao: "20 min" },
      { titulo: "Sexo tântrico para iniciantes", duracao: "26 min" },
    ],
    citacao: "Performance não é sobre durar mais. É sobre estar completamente presente.",
    gradiente: "from-purple-500 to-violet-600",
  },
  {
    nome: "Lady Milf",
    especialidade: "Relacionamento & Sexualidade",
    foto: "/images/instrutores/lady-milf.jpeg",
    bio: "Criadora de conteúdo e palestrante que transformou suas próprias experiências em educação sexual de verdade. Fala sobre relacionamento, desejo e sexualidade com a franqueza de quem viveu — não de quem leu sobre o assunto.",
    badge: "Relacionamentos · Sedução",
    trilhas: ["Relacionamentos Abertos", "Sedução", "Massagens Sensuais"],
    aulas: [
      { titulo: "Desejo de longo prazo: como manter", duracao: "25 min" },
      { titulo: "Comunicação sexual sem vergonha", duracao: "19 min" },
      { titulo: "Sedução depois dos 35", duracao: "22 min" },
    ],
    citacao: "A intimidade mais profunda começa com uma conversa honesta.",
    gradiente: "from-fuchsia-500 to-pink-600",
  },
  {
    nome: "Nego Catra",
    especialidade: "Diversidade & BDSM",
    foto: "/images/instrutores/nego-catra.jpeg",
    bio: "Ator, criador de conteúdo e palestrante que une arte, palco e sexualidade. Traz para a Rati uma visão de prazer construída na prática — com o corpo, a experiência e tudo que aprendeu sendo quem é.",
    badge: "BDSM · Prazer sem rótulo",
    trilhas: ["BDSM", "Fetiches & Fantasias", "Prazer Masculino"],
    aulas: [
      { titulo: "BDSM com segurança e consentimento", duracao: "28 min" },
      { titulo: "Fetiches sem julgamento", duracao: "23 min" },
      { titulo: "Prazer sem rótulo", duracao: "19 min" },
    ],
    citacao: "Seu prazer não precisa de rótulos — só de respeito e informação.",
    gradiente: "from-indigo-500 to-purple-600",
  },
 ] satisfies LandingPageInstrutor[];

function hasText(value: unknown): value is string {
  return typeof value === 'string' && value.trim().length > 0;
}

function hasStringArray(value: unknown): value is string[] {
  return Array.isArray(value) && value.some((item) => hasText(item));
}

function hasAulas(value: unknown): value is LandingPageInstrutor['aulas'] {
  return Array.isArray(value) && value.some((item) => {
    if (!item || typeof item !== 'object') {
      return false;
    }

    const aula = item as Partial<LandingPageInstrutor['aulas'][number]>;
    return hasText(aula.titulo) || hasText(aula.duracao);
  });
}

function mergeLandingCollection<T extends object>(
  mapped: Array<Partial<T>> | undefined,
  fallback: T[],
  hasMappedContent: (item: Partial<T>) => boolean,
): T[] {
  if (!Array.isArray(mapped) || mapped.length === 0) {
    return fallback;
  }

  const total = Math.max(mapped.length, fallback.length);

  return Array.from({ length: total }, (_, index) => {
    const mappedItem = mapped[index];
    const fallbackItem = fallback[index];

    if (mappedItem && hasMappedContent(mappedItem)) {
      if (!fallbackItem) {
        return mappedItem as T;
      }

      return { ...fallbackItem, ...mappedItem };
    }

    return fallbackItem;
  }).filter((item): item is T => Boolean(item));
}

function mergeFixedLandingCollection<T extends object>(
  mapped: Array<Partial<T>> | undefined,
  fallback: T[],
  hasMappedContent: (item: Partial<T>) => boolean,
): T[] {
  if (!Array.isArray(mapped) || mapped.length === 0) {
    return fallback;
  }

  return fallback.map((fallbackItem, index) => {
    const mappedItem = mapped[index];

    if (mappedItem && hasMappedContent(mappedItem)) {
      return { ...fallbackItem, ...mappedItem };
    }

    return fallbackItem;
  });
}

const barData1 = [
  { label: "Prazer & saúde", pct: 88 },
  { label: "Conexão afetiva", pct: 74 },
  { label: "Comunicação íntima", pct: 68 },
  { label: "Autoconhecimento", pct: 61 },
  { label: "Relacionamentos", pct: 53 },
] satisfies LandingPageStatsBar[];

const barData2 = [
  { label: "18–24 anos", pct: 38, dim: true },
  { label: "25–34 anos", pct: 62 },
  { label: "35–44 anos", pct: 81 },
  { label: "45–55 anos", pct: 75 },
  { label: "55–65 anos", pct: 49 },
] satisfies LandingPageStatsBar[];

const fallbackStats = {
  title: "O que brasileiros adultos realmente querem aprender.",
  subtitle:
    "Levantamos os dados. Brasileiros querem aprender mais sobre sexualidade — e não encontram conteúdo sério. A Rati foi criada para resolver isso.",
  bigPct: 72,
  bigText:
    "dos adultos brasileiros querem aprender mais sobre sexualidade — e não encontram conteúdo sério.",
  secondaryPct: 89,
  secondaryText: "consideram os cursos atuais caros para o que entregam.",
  donutF: 58,
  donutM: 42,
  bars1: barData1,
  bars2: barData2,
  source: "Pesquisa Rati Educação, 2024 (n=4.200)",
  femaleGrowth: "Crescimento de +34% no acesso feminino entre 2021–2024.",
} satisfies LandingPageStats;

const fallbackDiferenciais = {
  title: "Educação sexual que respeita sua inteligência.",
  subtitle:
    "Sem enrolação, sem julgamento, sem pseudociência. Só o que você precisa saber — ensinado por quem realmente entende.",
  cards: diferenciaisCards,
} satisfies LandingPageDiferenciais;

const fallbackFinalCta = {
  title: "Você já sabe que quer aprender. Agora é a hora.",
  subtitle:
    "Conteúdo real, instrutores de verdade, preço que cabe no bolso. Experimente 7 dias — se não for o que esperava, devolvemos tudo.",
  button: "Começar agora — 7 dias de garantia",
  link: "",
  disclaimer:
    "Assinatura discreta · Cancele quando quiser · 7 dias ou seu dinheiro de volta",
} satisfies LandingPageCTA;

const landingData = getLandingPageData();
const heroCtas = landingData.hero;

const heroBadge = (landingData.hero.badge ?? 'Maiores de 18 anos').toUpperCase();
const heroTitlePart1 = (landingData.hero.title_part1 ?? 'APRENDA').trim();
const heroTitlePart2Raw = (landingData.hero.title_part2 ?? 'O que ninguém te ensinou.').replace(/\r\n/g, '\n');
const heroTitlePart2 = heroTitlePart2Raw.trim();
const heroSubtitle =
  landingData.hero.subtitle?.trim() ||
  'Com especialistas que praticam o que ensinam. 13 trilhas temáticas — você aprende no seu ritmo, sobre o que realmente interessa.';

const heroSlides = mergeLandingCollection<LandingPageHeroSlide>(
  landingData.hero.slides,
  fallbackHeroSlides,
  (item) => {
    return hasText(item.url) || hasText(item.alt) || hasText(item.overlay);
  },
);
const heroMobileImage = landingData.hero.bg_mobile ?? heroSlides[0]?.url ?? fallbackHeroSlides[0].url;
const heroMobileAlt = heroSlides[0]?.alt ?? fallbackHeroSlides[0].alt;

const heroHighlights = mergeLandingCollection(landingData.heroHighlights, fallbackHeroHighlights, (item) => {
  return hasText(item.num) || hasText(item.label);
});

const trilhas = mergeLandingCollection(landingData.trilhas, fallbackTrilhas, (item) => {
  return (
    hasText(item.id) ||
    hasText(item.num) ||
    hasText(item.nome) ||
    typeof item.icon === 'function' ||
    hasText(item.cor) ||
    hasText(item.gradiente) ||
    hasText(item.descricao) ||
    hasText(item.imagem) ||
    hasText(item.imagemAlt)
  );
});

const assinaturaPlanos = mergeLandingCollection(landingData.assinaturaPlanos, fallbackAssinaturaPlanos, (item) => {
  return (
    hasText(item.nome) ||
    hasText(item.tagline) ||
    hasText(item.preco) ||
    hasText(item.centavos) ||
    hasText(item.periodo) ||
    typeof item.popular === 'boolean' ||
    hasStringArray(item.recursos) ||
    hasText(item.cta) ||
    hasText(item.link)
  );
});

const instrutores = mergeLandingCollection(landingData.instrutores, fallbackInstrutores, (item) => {
  return (
    hasText(item.nome) ||
    hasText(item.especialidade) ||
    hasText(item.foto) ||
    hasText(item.bio) ||
    hasText(item.badge) ||
    hasStringArray(item.trilhas) ||
    hasAulas(item.aulas) ||
    hasText(item.citacao) ||
    hasText(item.gradiente)
  );
});

const blogPreviewTitle = landingData.blogPreview.title ?? 'Experimente o conteúdo. Sem pagar nada.';
const blogPreviewSubtitle =
  landingData.blogPreview.subtitle ??
  'Artigos escritos com o mesmo padrão das aulas. Se você curtir o conteúdo gratuito, as aulas são ainda melhores.';
const blogPreviewCount = typeof landingData.blogPreview.count === 'number' ? landingData.blogPreview.count : 7;
const cleanPostExcerpt = (raw: string) => {
  if (!raw) return '';
  return raw
    .replace(/<a[\s\S]*?<\/a>/gi, '')
    .replace(/&lt;a[\s\S]*?&lt;\/a&gt;/gi, '')
    .replace(/<[^>]+>/g, '')
    .replace(/&[^;]+;/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

const blogPreviewPosts = (landingData.blogPreview.posts ?? [])
  .map((post) => {
    const slug = (post.slug ?? '').replace(/^\/+|\/+$/g, '');
    let url = (post.url ?? '').trim();
    if (url.startsWith('/blog/')) {
      url = url.replace(/^\/blog\//, '/');
    }
    if (!url && slug) {
      url = `/${slug}/`;
    }
    return {
      id: typeof post.id === 'number' ? post.id : 0,
      slug,
      url,
      titulo: post.titulo ?? '',
      categorias: post.categorias ?? [],
      imagem: post.imagem ?? '',
      imagemAlt: post.imagemAlt ?? post.titulo ?? '',
      excerpt: cleanPostExcerpt(post.excerpt ?? ''),
    };
  })
  .filter((post) => hasText(post.titulo) && (hasText(post.url) || hasText(post.slug)))
  .slice(0, blogPreviewCount) as LandingPageBlogPreviewPost[];
const blogPosts = blogPreviewPosts;

const contrasteRows = mergeLandingCollection(landingData.contrasteRows, fallbackContrasteRows, (item) => {
  return hasText(item.tema) || hasText(item.problema) || hasText(item.solucao);
});

const objecoes = mergeLandingCollection(landingData.objecoes, fallbackObjecoes, (item) => {
  return typeof item.Icon === 'function' || hasText(item.problema) || hasText(item.solucao);
});

const statsData = {
  ...fallbackStats,
  ...landingData.stats,
  bars1: mergeFixedLandingCollection<LandingPageStatsBar>(
    landingData.stats.bars1,
    fallbackStats.bars1,
    (item) => {
      return hasText(item.label) || typeof item.pct === 'number' || typeof item.dim === 'boolean';
    },
  ),
  bars2: mergeFixedLandingCollection<LandingPageStatsBar>(
    landingData.stats.bars2,
    fallbackStats.bars2,
    (item) => {
      return hasText(item.label) || typeof item.pct === 'number' || typeof item.dim === 'boolean';
    },
  ),
} satisfies LandingPageStats;

const diferenciaisData = {
  ...fallbackDiferenciais,
  ...landingData.diferenciais,
  cards: mergeFixedLandingCollection<LandingPageDiferencialCard>(
    landingData.diferenciais.cards,
    fallbackDiferenciais.cards,
    (item) => {
      return typeof item.icon === 'function' || hasText(item.titulo) || hasText(item.texto);
    },
  ),
} satisfies LandingPageDiferenciais;

const finalCtaData = {
  ...fallbackFinalCta,
  ...landingData.cta,
} satisfies LandingPageCTA;

/* ── CHARTS ───────────────────────────────────────────────── */

function AnimatedCounter({ to, inView, delay = 0 }: { to: number; inView: boolean; delay?: number }) {
  const [val, setVal] = useState(0);
  useEffect(() => {
    if (!inView) return;
    const tid = setTimeout(() => {
      const duration = 1100;
      const start = Date.now();
      const tick = () => {
        const progress = Math.min((Date.now() - start) / duration, 1);
        setVal(Math.round((1 - Math.pow(1 - progress, 3)) * to));
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }, delay);
    return () => clearTimeout(tid);
  }, [inView, to, delay]);
  return <>{val}</>;
}

function StatsCard({
  stats,
}: {
  stats: Pick<
    LandingPageStats,
    'bigPct' | 'bigText' | 'secondaryPct' | 'secondaryText' | 'source'
  >;
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: 0.1 }}
      className="overflow-hidden rounded-3xl bg-white/4 glass-soft"
    >
      <div className="h-1 w-full bg-gradient-to-r from-pink-500 via-fuchsia-500 to-purple-600" />
      <div className="flex h-full flex-col p-5 md:p-8">
        <span className="mb-6 block text-[10px] font-bold uppercase tracking-[0.15em] text-pink-400/70 md:mb-8" style={BODY}>O que os dados revelam</span>
        <div className="relative flex-1 grid-cols-1 gap-6 md:grid md:grid-cols-2 md:items-center md:gap-8">
          {/* Coluna 1 */}
          <div className="flex flex-col gap-3">
            <div className="flex items-baseline gap-3">
              <span className="bg-gradient-to-br from-pink-400 via-fuchsia-400 to-purple-400 bg-clip-text text-6xl leading-none text-transparent tabular-nums md:text-8xl" style={HEADING}>
                <AnimatedCounter to={stats.bigPct} inView={inView} />%
              </span>
              <span className="w-2 h-2 rounded-full bg-pink-400 animate-pulse self-start mt-4" />
            </div>
            <p className="text-sm text-white/70 leading-[1.7]" style={BODY}>
              {stats.bigText}
            </p>
            <p className="text-[10px] text-white/30 mt-1" style={BODY}>¹ {stats.source}</p>
          </div>

          {/* Divisor vertical */}
          <div className="my-1 h-px bg-gradient-to-r from-white/0 via-white/10 to-white/0 md:absolute md:bottom-0 md:left-1/2 md:top-0 md:my-0 md:h-auto md:w-px md:bg-gradient-to-b" />

          {/* Coluna 2 */}
          <div className="flex flex-col gap-3">
            <div className="flex items-baseline gap-3">
              <span className="text-5xl leading-none text-rose-400 tabular-nums md:text-7xl" style={HEADING}>
                <AnimatedCounter to={stats.secondaryPct} inView={inView} delay={400} />%
              </span>
              <span className="w-2 h-2 rounded-full bg-rose-400 animate-pulse self-start mt-3" />
            </div>
            <p className="text-sm text-white/70 leading-[1.7]" style={BODY}>
              {stats.secondaryText}
            </p>
            <p className="text-[10px] text-white/30 mt-1" style={BODY}>¹ {stats.source}</p>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

function BarChart({ data }: { data: { label: string; pct: number; dim?: boolean }[] }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const max = Math.max(...data.map(d => d.pct));
  return (
    <div ref={ref} className="flex flex-col gap-3 w-full">
      {data.map((row, i) => {
        const isMax = row.pct === max;
        return (
          <div key={row.label} className="flex items-center gap-2.5 md:gap-3">
            <span className="w-24 flex-shrink-0 text-right text-[11px] leading-tight text-white/80 md:w-28 md:text-xs" style={BODY}>{row.label}</span>
            <div className="flex-1 relative">
              <div className="h-4 overflow-hidden rounded-full bg-white/5 md:h-5">
                <motion.div
                  className="h-full rounded-full relative overflow-hidden bg-gradient-to-r from-rose-400 via-pink-400 to-fuchsia-500"
                  style={{ filter: 'brightness(1.1) saturate(1.15)' }}
                  initial={{ width: 0 }}
                  animate={{ width: inView ? `${row.pct}%` : 0 }}
                  transition={{ duration: 0.9, delay: i * 0.1, ease: [0.22, 1, 0.36, 1] }}
                >
                  <div className="absolute inset-0 bg-gradient-to-r from-white/10 via-white/30 to-transparent" />
                </motion.div>
              </div>
              {isMax && (
                <div className="absolute inset-y-0 left-0 rounded-full pointer-events-none" style={{ width: `${row.pct}%`, boxShadow: '0 0 14px 2px rgba(249,168,212,0.25)' }} />
              )}
              <div className="absolute top-0 bottom-0 left-[50%] w-px bg-white/8 pointer-events-none" />
            </div>
            <span className="w-10 flex-shrink-0 text-right text-xs tabular-nums text-white/80 md:text-sm" style={{ ...BODY, fontWeight: 800 }}>
              <AnimatedCounter to={row.pct} inView={inView} delay={i * 100 + 200} />%
            </span>
          </div>
        );
      })}
      <div className="flex items-center gap-3 mt-1">
        <div className="w-28 flex-shrink-0" />
        <div className="flex-1 flex justify-between">
          <span className="text-[9px] text-white/22" style={BODY}>0%</span>
          <span className="text-[9px] text-white/22" style={BODY}>50%</span>
          <span className="text-[9px] text-white/22" style={BODY}>100%</span>
        </div>
        <div className="w-10 flex-shrink-0" />
      </div>
    </div>
  );
}

function DonutChart({
  donutF,
  donutM,
  femaleGrowth,
}: Pick<LandingPageStats, 'donutF' | 'donutM' | 'femaleGrowth'>) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const shouldReduceMotion = useReducedMotion();
  const size = 240;
  const r = 90;
  const cx = size / 2;
  const cy = size / 2;
  const circ = 2 * Math.PI * r;
  const segments = [
    { pct: donutF / 100, color: '#F72585', label: 'Mulheres', val: donutF, sub: 'maioria na plataforma', swatch: 'from-pink-500 to-rose-500', delay: 0 },
    { pct: donutM / 100, color: '#8338EC', label: 'Homens', val: donutM, sub: 'crescimento constante', swatch: 'from-purple-500 to-violet-500', delay: 0.28 },
  ];
  let dashOffset = 0;
  return (
    <div ref={ref} className="flex h-full flex-col items-center gap-8 lg:flex-row lg:items-center">
      {/* Gráfico à esquerda */}
      <div className="relative hidden shrink-0 items-center justify-center md:flex">
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          {/* Track */}
          <circle cx={cx} cy={cy} r={r} fill="none" stroke="rgba(255,255,255,0.04)" strokeWidth="24" />
          {/* Segments */}
          {segments.map((seg, si) => {
            const offset = dashOffset;
            dashOffset += seg.pct;
            const targetDasharray = `${circ * seg.pct} ${circ}`;
            const chartReady = inView || shouldReduceMotion;
            return (
              <motion.circle
                key={seg.label}
                cx={cx}
                cy={cy}
                r={r}
                fill="none"
                stroke={seg.color}
                strokeWidth={24}
                strokeLinecap="butt"
                strokeDasharray={targetDasharray}
                strokeDashoffset={-(circ * offset)}
                transform={`rotate(-90 ${cx} ${cy})`}
                initial={{ strokeDasharray: shouldReduceMotion ? targetDasharray : `0 ${circ}` }}
                animate={{ strokeDasharray: chartReady ? targetDasharray : `0 ${circ}` }}
                transition={shouldReduceMotion ? { duration: 0 } : { duration: 1.1, delay: seg.delay, ease: [0.22, 1, 0.36, 1] }}
              />
            );
          })}
          {/* Center */}
          <text x={cx} y={cy - 8} textAnchor="middle" fill="white" fontFamily="Playfair Display, serif" fontSize="34" fontWeight="700">
            <AnimatedCounter to={donutF} inView={inView} />%
          </text>
          <text x={cx} y={cy + 18} textAnchor="middle" fill="rgba(255,255,255,0.45)" fontSize="11" fontFamily="Nunito, sans-serif" letterSpacing="2">MULHERES</text>
        </svg>
      </div>
      {/* Legend cards à direita em coluna */}
      <div className="flex h-full flex-1 flex-col justify-between self-stretch">
        <div className="flex flex-col gap-3">
          {segments.map(seg => (
            <div key={seg.label} className="flex flex-col gap-2.5 px-5 py-3 rounded-2xl bg-white/5 border border-white/8">
              <div className={`h-1 w-10 rounded-full bg-gradient-to-r ${seg.swatch}`} />
              <div className="flex items-baseline gap-3">
                <div className="text-4xl text-white tabular-nums leading-none" style={HEADING}>
                  <AnimatedCounter to={seg.val} inView={inView} delay={600} />%
                </div>
                <div className="text-sm font-semibold text-white/70" style={BODY}>{seg.label}</div>
              </div>
              <div className="text-[10px] text-white/35 leading-snug" style={BODY}>{seg.sub}</div>
            </div>
          ))}
        </div>
        <p className="text-xs text-white/35 leading-relaxed mt-3" style={BODY}>
          {femaleGrowth}
        </p>
      </div>
    </div>
  );
}

/* ── HERO SLIDER ──────────────────────────────────────────── */

function HeroSlider({ slides, badge }: { slides: LandingPageHeroSlide[]; badge: string }) {
  const [current, setCurrent] = useState(0);
  const currentSlide = slides[current] ?? slides[0];

  useEffect(() => {
    if (current >= slides.length) {
      setCurrent(0);
    }
  }, [current, slides.length]);

  useEffect(() => {
    if (slides.length <= 1) {
      return undefined;
    }

    const timer = setInterval(() => {
      setCurrent(prev => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 0.8 }}
      className="relative hidden lg:block gpu-layer"
      style={{ willChange: 'transform, opacity' }}
    >
      {/* Glow */}
      <div className="absolute -inset-4 rounded-3xl bg-gradient-to-r from-pink-500 to-purple-600 opacity-18 blur-2xl" />

      {/* Frame */}
      <div className="relative rounded-3xl overflow-hidden border border-white/15 shadow-2xl shadow-pink-500/20 bg-black" style={{ height: 620 }}>
        {/* Slides */}
        <AnimatePresence mode="wait">
          <motion.div
            key={current}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2, ease: 'easeInOut' }}
            className="absolute inset-0 gpu-layer"
          >
            <img
              src={currentSlide.url}
              alt={currentSlide.alt}
              className="w-full h-full object-cover object-center"
            />
            {/* Gradient overlay — keeps mood dark & on-brand */}
            <div className={`absolute inset-0 bg-gradient-to-br ${currentSlide.overlay}`} />
            {/* Bottom vignette so image blends into black bg */}
            <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-black/60 to-transparent" />
          </motion.div>
        </AnimatePresence>

        {/* Pink neon border shimmer */}
        <div className="absolute inset-0 rounded-3xl ring-1 ring-inset ring-white/10 pointer-events-none" />

        {/* Dot indicators */}
        <div className="absolute bottom-5 left-1/2 -translate-x-1/2 flex gap-2 z-10">
          {slides.map((_, i) => (
            <button
              key={i}
              type="button"
              onClick={() => setCurrent(i)}
              className={`transition-all duration-500 rounded-full ${
                i === current
                  ? 'w-8 h-2 bg-gradient-to-r from-pink-500 to-purple-500'
                  : 'w-2 h-2 bg-white/30 hover:bg-white/60'
              }`}
            />
          ))}
        </div>

        {/* Corner tag */}
        <div className="absolute top-5 left-5 z-10">
          <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-black/50 backdrop-blur border border-white/15 text-xs font-semibold tracking-wide" style={BODY}>
            <span className="w-1.5 h-1.5 rounded-full bg-pink-400 animate-pulse" />
            {badge}
          </div>
        </div>
      </div>
    </motion.div>
  );
}

/* ── INSTRUCTOR MODAL ─────────────────────────────────────── */

function InstructorModal({ instrutor, onClose }: { instrutor: typeof instrutores[0]; onClose: () => void }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-[200] flex items-center justify-center p-4 md:p-8"
      onClick={onClose}
    >
      <div className="absolute inset-0 bg-black/80 glass-soft" />
      <motion.div
        initial={{ opacity: 0, scale: 0.95, y: 20 }}
        animate={{ opacity: 1, scale: 1, y: 0 }}
        exit={{ opacity: 0, scale: 0.95, y: 20 }}
        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
        onClick={e => e.stopPropagation()}
        data-scroll-overlay="true"
        className="relative w-full max-w-3xl mx-4 bg-[#0d0d0d] border border-white/10 rounded-3xl overflow-hidden shadow-2xl max-h-[90vh] overflow-y-auto"
        style={{ willChange: 'transform, opacity' }}
      >
        {/* Top image band */}
        <div className="relative h-64 md:h-80 overflow-hidden">
          <img src={instrutor.foto} alt={instrutor.nome} loading="lazy" decoding="async" className="w-full h-full object-cover object-top" />
          <div className={`absolute inset-0 bg-gradient-to-t from-[#0d0d0d] via-black/40 to-transparent`} />
          <div className={`absolute inset-0 bg-gradient-to-br ${instrutor.gradiente} opacity-20`} />
          <button onClick={onClose} className="absolute top-4 right-4 w-10 h-10 rounded-full bg-black/60 glass-soft border border-white/20 flex items-center justify-center hover:bg-black/80 transition-colors">
            <X size={18} />
          </button>
          <div className="absolute bottom-0 left-0 p-8">
            <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gradient-to-r ${instrutor.gradiente} text-white text-xs font-bold tracking-wide mb-3`} style={BODY}>
              {instrutor.especialidade}
            </div>
            <h3 className="text-4xl text-white" style={HEADING}>{instrutor.nome}</h3>
          </div>
        </div>

        {/* Content */}
        <div className="p-5 md:p-8 flex flex-col gap-8">
          {/* Quote */}
          <blockquote className="border-l-2 border-pink-500 pl-5">
            <p
              className="text-xl text-white/90 italic leading-relaxed"
              style={HEADING}
              dangerouslySetInnerHTML={{ __html: `&ldquo;${instrutor.citacao}&rdquo;` }}
            />
          </blockquote>

          <p className="text-white/80 leading-[1.8]" style={BODY}>{instrutor.bio}</p>

          <div className="flex items-center gap-3 px-5 py-3.5 rounded-2xl bg-white/5 border border-white/10 self-start">
            <IconCircleCheck size={20} className="text-pink-400 flex-shrink-0" />
            <span className="text-sm font-semibold text-white/80" style={BODY}>{instrutor.badge}</span>
          </div>

          {/* Trilhas */}
          <div>
            <h4 className="text-sm font-bold tracking-widest uppercase text-white/50 mb-4" style={BODY}>Trilhas que leciona</h4>
            <div className="flex flex-wrap gap-2">
              {instrutor.trilhas.map(t => (
                <span key={t} className={`px-4 py-2 rounded-full text-xs font-semibold tracking-wide bg-gradient-to-r ${instrutor.gradiente} bg-opacity-15 border border-white/15`} style={BODY}>{t}</span>
              ))}
            </div>
          </div>

          {/* Aulas */}
          <div>
            <h4 className="text-sm font-bold tracking-widest uppercase text-white/50 mb-4" style={BODY}>Prévia das aulas</h4>
            <div className="flex flex-col gap-3">
              {instrutor.aulas.map((aula, i) => (
                <div key={i} className="flex items-center justify-between px-5 py-4 rounded-2xl bg-white/5 border border-white/8 group hover:border-pink-500/30 transition-colors cursor-pointer">
                  <div className="flex items-center gap-3">
                    <div className={`w-9 h-9 rounded-xl bg-gradient-to-r ${instrutor.gradiente} flex items-center justify-center flex-shrink-0`}>
                      <Play size={14} className="text-white ml-0.5" />
                    </div>
                    <span className="text-sm text-white/82 font-semibold" style={BODY}>{aula.titulo}</span>
                  </div>
                  <span className="text-xs text-white/45 flex-shrink-0 ml-4" style={BODY}>{aula.duracao}</span>
                </div>
              ))}
            </div>
          </div>

          <motion.button
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            onClick={onClose}
            className={`w-full py-4 rounded-full bg-gradient-to-r ${instrutor.gradiente} font-bold text-base tracking-wide shadow-lg`}
            style={BODY}
          >
            Ver todas as aulas →
          </motion.button>
        </div>
      </motion.div>
    </motion.div>
  );
}

function TrilhaDetailCard({
  trilha,
  onIniciarQuiz,
}: {
  trilha: typeof trilhas[number];
  onIniciarQuiz: () => void;
}) {
  return (
    <div className="relative flex h-full flex-col overflow-hidden">
      <div className={`absolute inset-0 bg-gradient-to-br ${trilha.gradiente} opacity-10`} />
      <div className="relative z-10 flex h-full flex-col">
        <div className="relative overflow-hidden border-b border-white/10">
          <img
            src={trilha.imagem}
            alt={trilha.imagemAlt}
            loading="lazy"
            decoding="async"
            className="h-64 w-full object-cover md:h-72"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#120312]/50 via-black/10 to-transparent" />
        </div>

        <div className="flex flex-1 flex-col p-6 md:p-10">
          <div className={`inline-flex items-center gap-2 rounded-full bg-gradient-to-r ${trilha.gradiente} px-4 py-2 text-sm font-semibold tracking-wide text-white self-start`} style={BODY}>
            <trilha.icon size={14} /> Sobre esta trilha
          </div>
          <h3 className="mt-4 text-3xl leading-tight text-white md:mt-5 md:text-5xl" style={HEADING}>{trilha.nome}</h3>
          <p className="mt-4 text-sm leading-[1.8] text-white/82 md:mt-6 md:text-lg md:leading-[1.9]" style={BODY}>{trilha.descricao}</p>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={onIniciarQuiz}
            className={`mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r ${trilha.gradiente} px-8 py-4 text-sm font-bold tracking-wide text-white shadow-lg md:mt-auto md:text-base`}
            style={BODY}
          >
            <Sparkles size={17} /> Descobrir minha trilha ideal
          </motion.button>
        </div>
      </div>
    </div>
  );
}

function TrilhaMobileCard({
  trilha,
  onIniciarQuiz,
}: {
  trilha: typeof trilhas[number];
  onIniciarQuiz: () => void;
}) {
  const Icon = trilha.icon;

  return (
    <div className="flex h-full min-h-[35rem] flex-col overflow-hidden rounded-[2rem] border border-white/8 bg-white/[0.04] glass-soft">
      <div className="relative overflow-hidden">
        <img
          src={trilha.imagem}
          alt={trilha.imagemAlt}
          loading="lazy"
          decoding="async"
          className="h-64 w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#120312]/55 via-black/15 to-transparent" />
      </div>

      <div className="flex flex-1 flex-col px-5 pb-5 pt-4">
        <div className={`mt-3 md:mt-0 inline-flex items-center leading-[11px] self-start rounded-full bg-gradient-to-r ${trilha.gradiente} px-3.5 py-2 text-[11px] font-semibold uppercase tracking-[0.12em] text-white`} style={BODY}>
          Sobre a trilha
        </div>

        <div className="mt-4 flex items-start gap-3 items-center ">
          <div className="flex md:h-11 md:w-11 flex-shrink-0 items-center justify-center rounded-2xl md:border md:border-white/10 md:bg-white/8">
            <Icon size={18} className="text-white" />
          </div>
          <h3 className="md:pt-0.5 text-[17px] md:text-[1.9rem] leading-[1.08] text-white text-balance" style={HEADING}>
            {trilha.nome}
          </h3>
        </div>

        <p className="mt-4 text-sm leading-[1.8] text-white/82" style={BODY}>
          {trilha.descricao}
        </p>

        <motion.button
          whileTap={{ scale: 0.98 }}
          onClick={onIniciarQuiz}
          className={`mt-6 flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r ${trilha.gradiente} px-6 py-4 text-sm font-bold tracking-wide text-white shadow-lg shadow-pink-500/20`}
          style={BODY}
        >
          <Sparkles size={17} /> Descobrir minha trilha ideal
        </motion.button>
      </div>
    </div>
  );
}

function MobileSliderDots({
  total,
  activeIndex,
  onSelect,
  labelPrefix,
}: {
  total: number;
  activeIndex: number;
  onSelect: (index: number) => void;
  labelPrefix: string;
}) {
  return (
    <div className="mt-6 flex justify-center gap-2">
      {Array.from({ length: total }).map((_, i) => (
        <button
          key={`${labelPrefix}-${i}`}
          type="button"
          onClick={() => onSelect(i)}
          aria-label={`Ir para ${labelPrefix} ${i + 1}`}
          className={`h-2 rounded-full transition-all ${i === activeIndex ? 'w-6 bg-gradient-to-r from-pink-500 to-purple-500' : 'w-2 bg-white/20'}`}
        />
      ))}
    </div>
  );
}

/* ── MAIN COMPONENT ───────────────────────────────────────── */

export function LandingPage({ onIniciarQuiz }: LandingPageProps) {
  const [menuAberto, setMenuAberto] = useState(false);
  const [trilhaSelecionada, setTrilhaSelecionada] = useState(trilhas[0]);
  const [planoSelecionado, setPlanoSelecionado] = useState(assinaturaPlanos[2]);
  const [modalInstrutor, setModalInstrutor] = useState<typeof instrutores[0] | null>(null);
  const [problemaSlide, setProblemaSlide] = useState(0);
  const [dadosSlide, setDadosSlide] = useState(0);
  const [diferenciaisSlide, setDiferenciaisSlide] = useState(0);
  const [trilhaSlide, setTrilhaSlide] = useState(0);
  const [objecoesSlide, setObjecoesSlide] = useState(0);
  const [blogDesktopSlide, setBlogDesktopSlide] = useState(0);
  const [blogDesktopSlideDirection, setBlogDesktopSlideDirection] = useState<'forward' | 'backward'>('forward');
  const [blogMobileSlide, setBlogMobileSlide] = useState(0);
  const [instrutorSlide, setInstrutorSlide] = useState(0);
  const problemaSwiperRef = useRef<SwiperType | null>(null);
  const dadosSwiperRef = useRef<SwiperType | null>(null);
  const diferenciaisSwiperRef = useRef<SwiperType | null>(null);
  const trilhaSwiperRef = useRef<SwiperType | null>(null);
  const objecoesSwiperRef = useRef<SwiperType | null>(null);
  const blogDesktopSwiperRef = useRef<SwiperType | null>(null);
  const blogMobileSwiperRef = useRef<SwiperType | null>(null);
  const instrutorSwiperRef = useRef<SwiperType | null>(null);
  const blogPreviousDesktopSlideRef = useRef(0);
  const [blogSliderOffsets, setBlogSliderOffsets] = useState({ before: 32, after: 32 });
  const BLOG_TOTAL = Math.min(blogPosts.length, blogPreviewCount) + 1;
  const BLOG_CARD_WIDTH = 300;
  const sectionLinks = [['Trilhas', 'trilhas'], ['Por que RATI', 'diferenciais'], ['Artigos', 'blog'], ['Planos', 'preco']] as const;

  const scrollToDesktopBlogCard = (idx: number) => {
    setBlogDesktopSlideDirection(idx >= blogDesktopSlide ? 'forward' : 'backward');
    blogDesktopSwiperRef.current?.slideTo(idx);
    setBlogDesktopSlide(idx);
  };

  const scrollToMobileBlogCard = (idx: number) => {
    blogMobileSwiperRef.current?.slideTo(idx);
    setBlogMobileSlide(idx);
  };

  const scrollToInstrutorCard = (idx: number) => {
    instrutorSwiperRef.current?.slideTo(idx);
    setInstrutorSlide(idx);
  };

  const scrollToProblemaCard = (idx: number) => {
    problemaSwiperRef.current?.slideTo(idx);
    setProblemaSlide(idx);
  };

  const scrollToDadosCard = (idx: number) => {
    dadosSwiperRef.current?.slideTo(idx);
    setDadosSlide(idx);
  };

  const scrollToDiferencialCard = (idx: number) => {
    diferenciaisSwiperRef.current?.slideTo(idx);
    setDiferenciaisSlide(idx);
  };

  const scrollToTrilhaCard = (idx: number) => {
    trilhaSwiperRef.current?.slideTo(idx);
    setTrilhaSlide(idx);
    setTrilhaSelecionada(trilhas[idx]);
  };

  const scrollToObjecaoCard = (idx: number) => {
    objecoesSwiperRef.current?.slideTo(idx);
    setObjecoesSlide(idx);
  };

  useEffect(() => {
    function updateBlogSliderOffsets() {
      const viewportWidth = window.innerWidth;
      const contentOffset = Math.max(32, (viewportWidth - 1280) / 2 + 32);
      const endOffset = Math.max(32, viewportWidth - contentOffset - BLOG_CARD_WIDTH);

      setBlogSliderOffsets({
        before: Math.round(contentOffset),
        after: Math.round(endOffset),
      });
    }

    updateBlogSliderOffsets();
    window.addEventListener('resize', updateBlogSliderOffsets);

    return () => {
      window.removeEventListener('resize', updateBlogSliderOffsets);
    };
  }, []);

  const scrollParaSecao = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuAberto(false);
  };

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      {/* BG */}
      <div className="fixed inset-0 z-0 pointer-events-none">
        <div className="absolute inset-0 bg-black" />
        <div className="absolute inset-0 hidden md:block opacity-45">
          <div className="ambient-blob ambient-blob-slow absolute top-0 -left-1/4 h-1/2 w-1/2 rounded-full bg-purple-600 mix-blend-multiply" />
          <div className="ambient-blob ambient-blob-slow absolute top-0 -right-1/4 h-1/2 w-1/2 rounded-full bg-pink-600 mix-blend-multiply" style={{ animationDelay: '1.6s' }} />
          <div className="ambient-blob ambient-blob-slow absolute -bottom-1/4 left-1/3 h-1/2 w-1/2 rounded-full bg-fuchsia-600 mix-blend-multiply" style={{ animationDelay: '0.8s' }} />
        </div>
      </div>

      {/* ── HEADER ── */}
      <motion.header initial={{ y: -100, opacity: 0 }} animate={{ y: 0, opacity: 1 }}
        className="fixed top-0 left-0 right-0 z-50 border-b border-white/10 glass-menu"
        style={{ willChange: 'transform, opacity' }}>
        <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 md:px-8">
          <img
            src="https://rati.com.br/wp-content/uploads/2020/12/logo-small.png"
            alt="RATI"
            width={92}
            height={32}
            decoding="async"
            className="h-8 object-contain"
          />
          <nav className="hidden md:flex items-center gap-10">
            {sectionLinks.map(([label, id]) => (
              <button key={id} onClick={() => scrollParaSecao(id)} className="text-sm tracking-wide text-white/75 hover:text-white transition-colors" style={BODY}>{label}</button>
            ))}
            <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
              onClick={() => scrollParaSecao('preco')}
              className="px-7 py-2.5 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 font-semibold text-sm tracking-wide" style={BODY}>
              Quero acesso completo
            </motion.button>
          </nav>
          <button onClick={() => setMenuAberto(!menuAberto)} className="md:hidden text-white p-2">
            {menuAberto ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
        <AnimatePresence>
          {menuAberto && (
            <motion.nav initial={{ opacity: 0, height: 0 }} animate={{ opacity: 1, height: 'auto' }} exit={{ opacity: 0, height: 0 }}
              className="md:hidden border-t border-white/10 glass-menu">
              <div className="flex flex-col gap-5 p-6">
                {sectionLinks.map(([label, id]) => (
                  <button key={id} onClick={() => scrollParaSecao(id)} className="text-left text-sm text-white/75" style={BODY}>{label}</button>
                ))}
              </div>
            </motion.nav>
          )}
        </AnimatePresence>
      </motion.header>

      <main className="relative z-10 flex flex-col">

      {/* ── HERO ── */}
      <section className="order-1 relative flex flex-col min-h-[76svh] items-center overflow-hidden px-0 md:px-5 md:pb-10 pt-28 md:min-h-[768px] md:px-8 md:pb-16 md:pt-24">
        <div className="absolute inset-0 md:hidden">
          <img src={heroMobileImage} alt={heroMobileAlt} fetchPriority="high" decoding="async" className="h-full w-full object-cover object-center opacity-45" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/38 via-black/60 to-black" />
          <div className="absolute inset-0 bg-gradient-to-br from-pink-900/22 via-transparent to-purple-900/16" />
          <div className="absolute inset-x-0 top-[18%] h-48 bg-gradient-to-b from-pink-500/8 to-transparent blur-3xl" />
        </div>
        
        <div className="mx-auto w-full max-w-7xl relative z-10 py-5 md:py-0">
          <div className="grid items-center gap-14 lg:grid-cols-2 lg:gap-16">
            <div className="flex flex-col items-center text-center md:items-start md:text-left">
              <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.3 }}
                className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-black/40 backdrop-blur px-3 md:px-4 py-2 md:py-2.5 glass-soft md:mb-8 md:gap-2.5 md:px-5">
                <span className="w-1.5 h-1.5 rounded-full bg-pink-400 animate-pulse" />
                <span className="text-[10px] leading-[10px] font-semibold uppercase tracking-[0.1em] md:tracking-[0.18em] sm:text-xs md:text-sm md:tracking-wider md:leading-relaxed" style={BODY}>{heroBadge}</span>
              </motion.div>
              <h1
                className="mx-auto mt-4 md:mt-0 mb-5 md:mb-4 max-w-[85vw] pb-1 text-[2.7rem] leading-[1.04] tracking-tight text-balance sm:text-5xl md:mx-0 md:mb-8 md:max-w-none md:text-7xl md:leading-[1.03] lg:text-8xl"
                style={{ ...HEADING, opacity: 1, transform: 'none' }}
              >
                {heroTitlePart1}
                {heroTitlePart2 && (
                  <span className="inline-block bg-gradient-to-r from-pink-500 via-purple-500 to-pink-500 bg-clip-text text-transparent italic pr-[0.08em] pb-[0.08em]">
                    {" "}{heroTitlePart2.trim()}
                  </span>
                )}
              </h1>
              <motion.p initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.5 }}
                className="mb-[5rem]  md:mb-6 max-w-[82vw] text-base leading-[1.72] text-white/84 sm:text-lg md:mb-12 md:max-w-xl md:text-lg md:leading-[1.8]" style={BODY}>
                {heroSubtitle}
              </motion.p>
              <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.6 }}
                className="mb-[3rem] md:mb-7 grid w-full max-w-[92vw] grid-cols-2 gap-3 md:mb-16 md:max-w-none md:flex md:flex-wrap md:gap-4">
                <motion.button whileHover={{ scale: 1.05, boxShadow: '0 0 40px rgba(236,72,153,0.5)' }} whileTap={{ scale: 0.95 }}
                  onClick={() => scrollParaSecao('preco')}
                  className="w-full rounded-full bg-gradient-to-r from-pink-500 to-purple-600 px-4 py-4 text-sm font-bold tracking-wide shadow-lg shadow-pink-500/40 md:w-auto md:px-9 md:text-base" style={BODY}>
                  {heroCtas.cta_primary}
                </motion.button>
                <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}
                  onClick={() => scrollParaSecao('trilhas')}
                  className="flex w-full items-center justify-center gap-2.5 rounded-full border border-white/25 bg-white/5 px-4 py-4 text-sm font-semibold tracking-wide text-white/90 glass-soft transition-colors hover:bg-white/10 md:w-auto md:px-9 md:text-base" style={BODY}>
                  {heroCtas.cta_secondary} <ArrowRight size={18} />
                </motion.button>
              </motion.div>
              <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.7 }}
                className="hidden w-full md:flex md:max-w-none md:flex-wrap md:gap-10">
                  {heroHighlights.map(({ num, label }) => (
                    <div key={label} className="text-center md:text-left">
                      <div className="bg-gradient-to-r from-pink-300 to-purple-400 bg-clip-text text-[2rem] leading-none text-transparent md:text-4xl" style={HEADING}>{num}</div>
                      <div className="mt-1.5 text-[10px] leading-snug text-white/62 md:text-sm" style={BODY}>{label}</div>
                    </div>
                  ))}
              </motion.div>
            </div>
            <HeroSlider slides={heroSlides} badge={heroBadge} />
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.7 }}
          className="hero-marquee relative left-1/2 mt-2 w-screen -translate-x-1/2 md:hidden  z-20"
        >
          <div className="hero-marquee-track">
            {[...heroHighlights, ...heroHighlights].map(({ num, label }, index) => (
              <div
                key={`${label}-${index}`}
                className="flex min-w-[8.75rem] shrink-0 flex-col items-center justify-center px-3.5 py-4 text-center"
              >
                <div className="bg-gradient-to-r from-pink-200 via-pink-300 to-purple-300 bg-clip-text text-[2.15rem] leading-none text-transparent" style={HEADING}>{num}</div>
                <div className="mt-2 text-[11px] font-semibold leading-snug text-white/80" style={BODY}>{label}</div>
              </div>
            ))}
          </div>
        </motion.div>
        <div className="pointer-events-none absolute inset-x-0 bottom-0 z-[1] h-24 bg-gradient-to-b from-transparent via-black/55 to-black md:hidden" />
      </section>

      {/* ── PROBLEMA ── */}
      <section className="order-4 relative px-5 py-16 md:order-2 md:px-8 md:pb-20 md:pt-28">
        <div className="max-w-4xl mx-auto relative z-10">
          <div className="flex flex-col items-center">

            {/* ── TÍTULO (centralizado acima) ── */}
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mx-auto mb-10 flex w-full max-w-[85vw] flex-col items-center text-center md:mx-auto md:mb-14 md:max-w-xl md:items-center md:text-center">
              <span className="mb-3 inline-block text-xs font-semibold uppercase tracking-[0.1em] text-pink-400 md:mb-5 md:text-sm md:tracking-widest" style={BODY}>Porque os outros cursos decepcionam</span>
              <h2 className="mb-4 text-3xl leading-[1.12] text-balance sm:text-4xl md:mb-6 md:text-6xl md:leading-tight" style={HEADING}>
                Você já pagou caro<span className="inline bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent italic md:block">para receber pouco...</span>
              </h2>
              <p className="mx-auto max-w-xl text-[15px] leading-[1.4] text-white/70 md:text-lg md:leading-relaxed" style={BODY}>
                A maioria dos cursos cobra caro e entrega pouco. Veja a diferença na prática.
              </p>
            </motion.div>

            <div className="w-full md:hidden">
              <Swiper
                onSwiper={(swiper) => {
                  problemaSwiperRef.current = swiper;
                }}
                onSlideChange={(swiper) => {
                  setProblemaSlide(swiper.activeIndex);
                }}
                slidesPerView={1.04}
                spaceBetween={16}
                speed={450}
                className="!overflow-visible min-h-[23rem]"
              >
                {contrasteRows.map((row, i) => {
                  const Icon = contrasteIcons[i];
                  return (
                    <SwiperSlide key={row.tema} className="!h-auto">
                      <motion.div
                        initial={{ opacity: 0, y: 18 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: 0.08 * i }}
                        className="h-full min-h-[23rem] overflow-hidden rounded-3xl border border-white/10 bg-white/[0.03]"
                      >
                        <div className="flex items-start gap-4 border-b border-white/8 bg-white/5 px-5 py-5">
                          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl border border-red-400/20 bg-red-400/10">
                            <Icon size={18} className="text-red-400" stroke={1.5} />
                          </div>
                          <div>
                            <span className="mb-2 block text-[11px] font-bold uppercase tracking-[0.22em] text-white/40" style={BODY}>Outros cursos</span>
                            <p className="text-sm leading-[1.7] text-white/72" style={BODY}>{row.problema}</p>
                          </div>
                        </div>
                        <div className="flex items-start gap-4 bg-gradient-to-r from-pink-500/10 to-purple-500/10 px-5 py-5">
                          <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl border border-pink-500/25 bg-pink-500/15">
                            <Icon size={18} className="text-pink-400" stroke={1.5} />
                          </div>
                          <div>
                            <span className="mb-2 block text-[11px] font-bold uppercase tracking-[0.22em] text-pink-400" style={BODY}>RATI</span>
                            <p className="text-sm font-semibold leading-[1.7] text-white/90" style={BODY}>{row.solucao}</p>
                          </div>
                        </div>
                      </motion.div>
                    </SwiperSlide>
                  );
                })}
              </Swiper>

              <MobileSliderDots
                total={contrasteRows.length}
                activeIndex={problemaSlide}
                onSelect={scrollToProblemaCard}
                labelPrefix="comparacao"
              />
            </div>

            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
              className="hidden w-full overflow-hidden rounded-2xl md:block"
              style={{ border: '1px solid rgba(255,255,255,0.08)' }}>

              <div className="grid grid-cols-2">

                {/* ── HEADER: Outros cursos ── */}
                <div className="px-8 py-6 flex items-center justify-center border-b border-r"
                  style={{ background: 'rgba(255,255,255,0.03)', borderColor: 'rgba(255,255,255,0.08)' }}>
                  <span className="text-base font-semibold text-white/40 tracking-widest uppercase text-center" style={BODY}>Outros cursos</span>
                </div>

                {/* ── HEADER: RATI logo ── */}
                <div className="px-8 py-6 flex items-center justify-center border-b"
                  style={{ background: 'rgba(255,0,110,0.07)', borderColor: 'rgba(255,0,110,0.18)' }}>
                  <img
                    src="https://rati.com.br/wp-content/uploads/2020/12/logo-small.png"
                    alt="RATI"
                    width={80}
                    height={28}
                    loading="lazy"
                    decoding="async"
                    className="h-7 object-contain"
                  />
                </div>

                {/* ── DATA ROWS ── */}
                {contrasteRows.flatMap((row, i) => {
                  const Icon = contrasteIcons[i];
                  const isLast = i === contrasteRows.length - 1;
                  const bdrRight = !isLast ? '1px solid rgba(255,255,255,0.06)' : 'none';
                  const bdrLeft  = !isLast ? '1px solid rgba(255,0,110,0.08)' : 'none';
                  return [
                    <motion.div key={`l-${i}`}
                      initial={{ opacity: 0, x: -12 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
                      transition={{ delay: 0.12 + i * 0.06 }}
                      className="px-7 py-6 flex items-center gap-5 border-r"
                      style={{ background: 'rgba(255,255,255,0.015)', borderRight: '1px solid rgba(255,255,255,0.07)', borderBottom: bdrRight }}>
                      <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
                        style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)' }}>
                        <Icon size={22} className="text-red-400" stroke={1.5} />
                      </div>
                      <p className="text-white/55 text-[1.05rem] leading-[1.7] tracking-wide" style={BODY}>{row.problema}</p>
                    </motion.div>,
                    <motion.div key={`r-${i}`}
                      initial={{ opacity: 0, x: 12 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}
                      transition={{ delay: 0.17 + i * 0.06 }}
                      className="px-7 py-6 flex items-center gap-5"
                      style={{ background: 'linear-gradient(160deg,rgba(255,0,110,0.06),rgba(114,9,183,0.08))', borderBottom: bdrLeft }}>
                      <div className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
                        style={{ background: 'rgba(255,0,110,0.14)', border: '1px solid rgba(255,0,110,0.28)' }}>
                        <Icon size={22} className="text-pink-400" stroke={1.5} />
                      </div>
                      <p className="text-white/90 text-[1.05rem] leading-[1.7] font-semibold tracking-wide" style={BODY}>{row.solucao}</p>
                    </motion.div>,
                  ];
                })}

              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: 0.16 }}
              className="mt-8 text-center"
            >
              <p className="mb-3 text-[13px] md:text-sm text-white/45 tracking-wide" style={BODY}>
                Entre com o menor ticket e explore tudo sem compromisso.
              </p>
              <motion.button
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                onClick={() => scrollParaSecao('preco')}
                className="px-8 py-4 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 font-bold text-base tracking-wide shadow-lg shadow-pink-500/25"
                style={BODY}
              >
                Acesso a partir de R$14,90
              </motion.button>
            </motion.div>

          </div>
        </div>
      </section>

      {/* ── DADOS ── */}
      <section className="order-5 relative px-5 pb-20 pt-4 md:order-3 md:px-8 md:pb-28 md:pt-8">
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mx-auto mb-10 flex max-w-[85vw] flex-col items-center text-center md:mx-0 md:mb-14 md:max-w-none md:items-start md:text-left">
            <span className="mb-2 inline-block text-[14px] font-regular uppercase tracking-[0.1em] text-pink-400 md:mb-5 md:text-sm md:tracking-widest" style={BODY}>O que os dados mostram</span>
            <h2 className="mb-4 text-3xl leading-[1.12] text-balance sm:text-4xl md:mb-6 md:text-6xl md:leading-tight" style={HEADING}>
              {statsData.title}
            </h2>
            <p className="max-w-2xl text-[15px] leading-[1.4] text-white/80 md:text-lg md:leading-relaxed" style={BODY}>
              {statsData.subtitle}
            </p>
          </motion.div>
          <div className="md:hidden">
            <Swiper
              onSwiper={(swiper) => {
                dadosSwiperRef.current = swiper;
              }}
              onSlideChange={(swiper) => {
                setDadosSlide(swiper.activeIndex);
              }}
              slidesPerView={1.04}
              spaceBetween={16}
              speed={450}
              className="!overflow-visible min-h-[36rem]"
            >
              <SwiperSlide className="!h-auto">
                <div className="min-h-[36rem]">
                  <StatsCard stats={statsData} />
                </div>
              </SwiperSlide>

              <SwiperSlide className="!h-auto">
                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}
                  className="h-full min-h-[36rem] overflow-hidden rounded-3xl bg-white/4 glass-soft">
                  <div className="h-1 w-full bg-gradient-to-r from-purple-600 via-fuchsia-500 to-pink-500" />
                  <div className="p-5 md:p-8 flex flex-col gap-6">
                    <div>
                      <span className="text-xs font-bold tracking-[0.12em] uppercase text-pink-400/85 block mb-1.5" style={BODY}>Temas mais buscados</span>
                      <p className="text-xs text-white/50" style={BODY}>adultos entre 35–55 anos no Brasil</p>
                    </div>
                    <BarChart data={statsData.bars1} />
                  </div>
                </motion.div>
              </SwiperSlide>

              <SwiperSlide className="!h-auto">
                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}
                  className="h-full min-h-[36rem] overflow-hidden rounded-3xl bg-white/4 glass-soft">
                  <div className="h-1 w-full bg-gradient-to-r from-pink-500 via-rose-500 to-fuchsia-500" />
                  <div className="p-5 md:p-8 flex flex-col gap-6">
                    <div>
                      <span className="text-xs font-bold tracking-[0.12em] uppercase text-pink-400/85 block mb-1.5" style={BODY}>Perfil do público</span>
                      <p className="text-xs text-white/50" style={BODY}>quem busca educação sexual online no Brasil</p>
                    </div>
                    <DonutChart
                      donutF={statsData.donutF}
                      donutM={statsData.donutM}
                      femaleGrowth={statsData.femaleGrowth}
                    />
                  </div>
                </motion.div>
              </SwiperSlide>

              <SwiperSlide className="!h-auto">
                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}
                  className="h-full min-h-[36rem] overflow-hidden rounded-3xl bg-white/4 glass-soft">
                  <div className="h-1 w-full bg-gradient-to-r from-fuchsia-600 via-purple-500 to-indigo-500" />
                  <div className="p-5 md:p-8 flex flex-col gap-6">
                    <div>
                      <span className="text-xs font-bold tracking-[0.12em] uppercase text-pink-400/85 block mb-1.5" style={BODY}>Faixa etária dos assinantes</span>
                      <p className="text-xs text-white/50" style={BODY}>quem mais busca educação sexual online no Brasil</p>
                    </div>
                    <BarChart data={statsData.bars2} />
                  </div>
                </motion.div>
              </SwiperSlide>
            </Swiper>

            <MobileSliderDots
              total={4}
              activeIndex={dadosSlide}
              onSelect={scrollToDadosCard}
              labelPrefix="dados"
            />
          </div>

          {/* 2×2 editorial grid */}
          <div className="hidden gap-5 md:grid md:grid-cols-2">

            {/* TOP-LEFT: Stats */}
            <StatsCard stats={statsData} />

            {/* TOP-RIGHT: Bar chart 1 */}
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}
              className="rounded-3xl overflow-hidden bg-white/4 glass-soft">
              <div className="h-1 w-full bg-gradient-to-r from-purple-600 via-fuchsia-500 to-pink-500" />
              <div className="p-8 flex flex-col gap-6">
                <div>
                  <span className="text-xs font-bold tracking-[0.12em] uppercase text-pink-400/85 block mb-1.5" style={BODY}>Temas mais buscados</span>
                  <p className="text-xs text-white/50" style={BODY}>adultos entre 35–55 anos no Brasil</p>
                </div>
                <BarChart data={statsData.bars1} />
              </div>
            </motion.div>

            {/* BOTTOM-LEFT: Donut */}
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.3 }}
              className="rounded-3xl overflow-hidden bg-white/4 glass-soft">
              <div className="h-1 w-full bg-gradient-to-r from-pink-500 via-rose-500 to-fuchsia-500" />
              <div className="p-8 flex flex-col gap-6">
                <div>
                  <span className="text-xs font-bold tracking-[0.12em] uppercase text-pink-400/85 block mb-1.5" style={BODY}>Perfil do público</span>
                  <p className="text-xs text-white/50" style={BODY}>quem busca educação sexual online no Brasil</p>
                </div>
                <DonutChart
                  donutF={statsData.donutF}
                  donutM={statsData.donutM}
                  femaleGrowth={statsData.femaleGrowth}
                />
              </div>
            </motion.div>

            {/* BOTTOM-RIGHT: Bar chart 2 */}
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.4 }}
              className="rounded-3xl overflow-hidden bg-white/4 glass-soft">
              <div className="h-1 w-full bg-gradient-to-r from-fuchsia-600 via-purple-500 to-indigo-500" />
              <div className="p-8 flex flex-col gap-6">
                <div>
                  <span className="text-xs font-bold tracking-[0.12em] uppercase text-pink-400/85 block mb-1.5" style={BODY}>Faixa etária dos assinantes</span>
                  <p className="text-xs text-white/50" style={BODY}>quem mais busca educação sexual online no Brasil</p>
                </div>
                <BarChart data={statsData.bars2} />
              </div>
            </motion.div>

          </div>

          <motion.section
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.25 }}
            className="mt-14 flex flex-col items-center gap-5 text-center md:mt-16"
          >
            <p className="max-w-[85vw] text-2xl leading-[1.2] text-balance text-white/78 md:max-w-2xl md:text-4xl md:leading-[1.12]" style={HEADING}>
              Não sabe por onde começar? A RATI te mostra a melhor entrada.
            </p>
            <motion.button
              whileHover={{ scale: 1.03, boxShadow: '0 0 38px rgba(236,72,153,0.32)' }}
              whileTap={{ scale: 0.97 }}
              onClick={() => scrollParaSecao('trilhas')}
              className="inline-flex items-center gap-2.5 rounded-full bg-gradient-to-r from-pink-500 via-fuchsia-500 to-purple-600 px-8 py-4 text-base font-bold tracking-wide text-white shadow-lg shadow-pink-500/35 transition-all hover:-translate-y-0.5 md:px-10 md:py-4"
              style={BODY}
            >
              Descubra sua trilha <ArrowRight size={18} />
            </motion.button>
          </motion.section>
        </div>
      </section>

      {/* ── DIFERENCIAIS ── */}
      <section id="diferenciais" className="order-6 relative px-5 py-20 md:order-4 md:px-8 md:py-28">
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mx-auto mb-10 flex max-w-[85vw] flex-col items-center text-center md:mx-0 md:mb-20 md:max-w-none md:items-start md:text-left">
            <span className="mb-3 inline-block text-xs font-semibold uppercase tracking-[0.1em] text-pink-400 md:mb-5 md:text-sm md:tracking-widest" style={BODY}>O que a RATI tem que os outros não têm</span>
            <h2 className="mb-4 text-3xl leading-[1.12] text-balance sm:text-4xl md:mb-6 md:text-6xl md:leading-tight" style={HEADING}>
              {diferenciaisData.title}
            </h2>
            <p className="max-w-2xl text-[15px] leading-[1.4] text-white/80 md:text-lg md:leading-relaxed" style={BODY}>{diferenciaisData.subtitle}</p>
          </motion.div>
          <div className="md:hidden">
            <Swiper
              onSwiper={(swiper) => {
                diferenciaisSwiperRef.current = swiper;
              }}
              onSlideChange={(swiper) => {
                setDiferenciaisSlide(swiper.activeIndex);
              }}
              slidesPerView={1.08}
              spaceBetween={16}
              speed={450}
              className="!overflow-visible min-h-[19rem]"
            >
              {diferenciaisData.cards.map((item, i) => (
                <SwiperSlide key={item.titulo} className="!h-auto">
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                    className="group h-full min-h-[19rem] rounded-3xl border border-white/10 bg-white/5 p-6 glass-soft">
                    <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-r from-pink-500 to-purple-600">
                      <item.icon size={26} className="text-white" />
                    </div>
                    <h3 className="mb-3 text-lg" style={HEADING}>{item.titulo}</h3>
                    <p className="text-sm leading-[1.7] text-white/78" style={BODY}>{item.texto}</p>
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>

            <MobileSliderDots
              total={diferenciaisData.cards.length}
              activeIndex={diferenciaisSlide}
              onSelect={scrollToDiferencialCard}
              labelPrefix="diferenciais"
            />
          </div>

          <div className="hidden gap-4 md:grid md:grid-cols-2 md:gap-6 lg:grid-cols-4">
            {diferenciaisData.cards.map((item, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                whileHover={{ y: -8, scale: 1.02 }}
                className="group rounded-3xl border border-white/10 bg-white/5 p-6 glass-soft transition-all hover:border-pink-500/50 md:p-9">
                <div className="mb-5 flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-r from-pink-500 to-purple-600 transition-transform group-hover:scale-110 md:mb-7 md:h-14 md:w-14">
                  <item.icon size={26} className="text-white" />
                </div>
                <h3 className="mb-3 text-lg md:text-xl" style={HEADING}>{item.titulo}</h3>
                <p className="text-sm leading-[1.7] text-white/78 md:text-base md:leading-relaxed" style={BODY}>{item.texto}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── TRILHAS ── */}
      <section id="trilhas" className=" order-2 relative px-5 pb-16 pt-20 md:pt-10 md:order-5 md:mt-0 md:px-8 md:py-28">
        <div className="pointer-events-none absolute inset-x-0 top-0 h-20 bg-gradient-to-b from-white/[0.04] via-transparent to-transparent md:hidden" />
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mx-auto mb-10 flex max-w-[92vw] flex-col items-center text-center glass-soft md:mx-0 md:mb-20 md:max-w-none md:items-start md:rounded-none md:border-0 md:bg-transparent md:px-0 md:py-0 md:text-left">
            <span className="mb-3 inline-block text-xs font-semibold uppercase tracking-[0.1em] text-pink-400 md:mb-5 md:text-sm md:tracking-widest" style={BODY}>O que você vai aprender</span>
            <h2 className="mb-4 text-3xl leading-[1.1] text-balance sm:text-4xl md:mb-6 md:text-6xl md:leading-tight" style={HEADING}>
              13 trilhas. <span className="inline bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent italic md:block">Você escolhe por onde começar.</span>
            </h2>
            <p className="max-w-2xl text-[15px] leading-[1.4] text-white/80 md:text-lg md:leading-relaxed" style={BODY}>
              Cada trilha tem começo, meio e fim. Você aprende de forma progressiva — sem precisar fuçar em catálogo.
            </p>
          </motion.div>

          <div className="hidden overflow-hidden rounded-3xl bg-white/5 glass-soft lg:grid lg:grid-cols-2 lg:gap-0">
            <div data-scroll-overlay="true" className="max-h-[768px] overflow-y-auto">
              {trilhas.map((trilha, i) => {
                const Icon = trilha.icon;
                return (
                  <motion.button key={trilha.id}
                    initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }}
                    onClick={() => setTrilhaSelecionada(trilha)}
                    className={`w-full flex items-center gap-5 px-7 py-5 border-b border-white/5 hover:bg-white/5 transition-all text-left group ${trilhaSelecionada.id === trilha.id ? 'bg-white/10 border-l-4 border-l-pink-500' : ''}`}>
                    <span className="text-xs text-white/30 w-6 flex-shrink-0" style={{ ...BODY, fontWeight: 700 }}>{trilha.num}</span>
                    <div className={`w-10 h-10 rounded-xl bg-gradient-to-r ${trilha.gradiente} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                      <Icon size={18} className="text-white" />
                    </div>
                    <div className="flex-1">
                      <div className={`font-semibold text-sm tracking-wide ${trilhaSelecionada.id === trilha.id ? 'text-white' : 'text-white/82'}`} style={BODY}>{trilha.nome}</div>
                    </div>
                    <ArrowRight size={16} className={`transition-all flex-shrink-0 ${trilhaSelecionada.id === trilha.id ? 'opacity-100 text-pink-500' : 'opacity-0 group-hover:opacity-50'}`} />
                  </motion.button>
                );
              })}
            </div>
            <AnimatePresence mode="wait">
              <motion.div key={trilhaSelecionada.id}
                initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }}
                className="relative overflow-hidden">
                <TrilhaDetailCard trilha={trilhaSelecionada} onIniciarQuiz={onIniciarQuiz} />
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="lg:hidden">
            <Swiper
              onSwiper={(swiper) => {
                trilhaSwiperRef.current = swiper;
              }}
              onSlideChange={(swiper) => {
                setTrilhaSlide(swiper.activeIndex);
                setTrilhaSelecionada(trilhas[swiper.activeIndex]);
              }}
              slidesPerView={1.08}
              spaceBetween={16}
              speed={480}
              className="!overflow-visible min-h-[35rem]"
            >
              {trilhas.map((trilha) => (
                <SwiperSlide key={trilha.id} className="!h-auto">
                  <TrilhaMobileCard trilha={trilha} onIniciarQuiz={onIniciarQuiz} />
                </SwiperSlide>
              ))}
            </Swiper>

            <MobileSliderDots
              total={trilhas.length}
              activeIndex={trilhaSlide}
              onSelect={scrollToTrilhaCard}
              labelPrefix="trilhas"
            />
          </div>
        </div>
      </section>

      {/* ── RESUMO DAS TRILHAS (abaixo das trilhas) ── */}
      <motion.section initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="hidden lg:flex flex-col items-center justify-center gap-7 border-y border-white/8 py-8 text-center md:py-10 order-10 md:order-6" aria-label="Resumo das trilhas">
        <div className="flex items-start justify-center gap-8 md:gap-14">
          {trilhaStats.map(({ num, label }) => (
            <div key={label} className="min-w-[7.5rem]">
              <div className="bg-gradient-to-r from-pink-300 via-fuchsia-400 to-purple-400 bg-clip-text text-4xl leading-none text-transparent md:text-5xl" style={HEADING}>{num}</div>
              <div className="mt-2 text-[11px] uppercase tracking-[0.14em] text-white/58 md:text-sm md:tracking-[0.18em]" style={BODY}>{label}</div>
            </div>
          ))}
        </div>
        <motion.button whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }} onClick={() => scrollParaSecao('preco')}
          className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 px-8 py-4 text-sm font-bold tracking-wide shadow-[0_20px_60px_rgba(236,72,153,0.28)] md:px-9 md:text-base" style={BODY}>
          <Play size={17} /> Acessar todas as trilhas
        </motion.button>
      </motion.section>

      {/* ── OBJEÇÕES ── */}
      <section className="order-7 relative px-5 py-20 md:order-7 md:px-8 md:py-28">
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mx-auto mb-10 flex max-w-[85vw] flex-col items-center text-center md:mx-0 md:mb-20 md:max-w-none md:items-start md:text-left">
            <span className="mb-3 inline-block text-xs font-semibold uppercase tracking-[0.1em] text-pink-400 md:mb-5 md:text-sm md:tracking-widest" style={BODY}>O que passa pela sua cabeça agora</span>
            <h2 className="mb-4 text-3xl leading-[1.12] text-balance sm:text-4xl md:mb-6 md:text-6xl md:leading-tight" style={HEADING}>
              Cada dúvida tem resposta. <span className="inline bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent italic md:block">Sem enrolação.</span>
            </h2>
            <p className="max-w-2xl text-[15px] leading-[1.4] text-white/80 md:text-lg md:leading-relaxed" style={BODY}>Respondemos as dúvidas que todo mundo tem mas poucos falam em voz alta.</p>
          </motion.div>

          <div className="md:hidden">
            <Swiper
              onSwiper={(swiper) => {
                objecoesSwiperRef.current = swiper;
              }}
              onSlideChange={(swiper) => {
                setObjecoesSlide(swiper.activeIndex);
              }}
              slidesPerView={1.05}
              spaceBetween={16}
              speed={500}
              className="!overflow-visible min-h-[20rem]"
            >
              {objecoes.map((obj, i) => (
                <SwiperSlide key={`objecao-${i}`} className="!h-auto">
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
                    className="h-full min-h-[20rem] rounded-3xl overflow-hidden border border-white/8 bg-white/[0.03]">
                    <div className="flex min-h-[152px] items-start gap-4 bg-white/5 px-5 py-5">
                      <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl border border-white/12 bg-white/8">
                        <obj.Icon size={22} className="text-white/60" stroke={1.5} />
                      </div>
                      <div className="flex-1 space-y-2.5 pt-0.5">
                        <span className="mb-2 block text-xs font-bold uppercase tracking-widest text-white/40" style={BODY}>Objeção</span>
                        <p className="text-sm leading-relaxed text-white/75" style={BODY}>{obj.problema}</p>
                      </div>
                    </div>
                    <div className="flex min-h-[152px] items-start gap-4 bg-gradient-to-r from-pink-500/8 to-purple-500/8 px-5 py-5">
                      <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl border border-pink-500/25 bg-pink-500/15">
                        <IconCircleCheck size={22} className="text-pink-400" stroke={1.5} />
                      </div>
                      <div className="flex-1 space-y-2.5 pt-0.5">
                        <span className="mb-2 block text-xs font-bold uppercase tracking-widest text-pink-400" style={BODY}>Realidade na Rati</span>
                        <p className="text-sm leading-relaxed text-white/85" style={BODY}>{obj.solucao}</p>
                      </div>
                    </div>
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>

            <MobileSliderDots
              total={objecoes.length}
              activeIndex={objecoesSlide}
              onSelect={scrollToObjecaoCard}
              labelPrefix="objecoes"
            />
          </div>

          <div className="hidden gap-4 md:grid md:grid-cols-2 md:gap-5">
            {objecoes.map((obj, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
                className="rounded-3xl overflow-hidden border border-white/8 bg-white/[0.03]">
                {/* Problema */}
                <div className="flex min-h-[152px] items-start gap-4 bg-white/5 px-5 py-5 md:gap-5 md:px-8 md:py-7">
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl border border-white/12 bg-white/8 md:h-11 md:w-11">
                    <obj.Icon size={22} className="text-white/60" stroke={1.5} />
                  </div>
                  <div className="flex-1 space-y-2.5 pt-0.5">
                    <span className="text-xs font-bold tracking-widest uppercase text-white/40 mb-2 block" style={BODY}>Objeção</span>
                    <p className="text-white/75 leading-relaxed text-sm" style={BODY}>{obj.problema}</p>
                  </div>
                </div>
                {/* Solução */}
                <div className="flex min-h-[152px] items-start gap-4 bg-gradient-to-r from-pink-500/8 to-purple-500/8 px-5 py-5 md:gap-5 md:px-8 md:py-7">
                  <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-2xl border border-pink-500/25 bg-pink-500/15 md:h-11 md:w-11">
                    <IconCircleCheck size={22} className="text-pink-400" stroke={1.5} />
                  </div>
                  <div className="flex-1 space-y-2.5 pt-0.5">
                    <span className="text-xs font-bold tracking-widest uppercase text-pink-400 mb-2 block" style={BODY}>Realidade na Rati</span>
                    <p className="text-white/85 leading-relaxed text-sm" style={BODY}>{obj.solucao}</p>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="mt-8 text-center"
          >
            <p className="mb-3 text- text-white/45 tracking-wide" style={BODY}>
              Se uma dessas objeções era sua, o próximo passo é entrar e explorar.
            </p>
            <motion.button
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
              onClick={() => scrollParaSecao('preco')}
              className="px-8 py-4 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 font-bold text-base tracking-wide shadow-lg shadow-pink-500/25"
              style={BODY}
            >
              Quero acesso completo
            </motion.button>
          </motion.div>
        </div>
      </section>

      {/* ── INSTRUTORES ── */}
      <section className="order-8 relative px-5 py-20 md:order-8 md:px-8 md:py-28">
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mx-auto mb-10 flex max-w-[85vw] flex-col items-center text-center md:mx-0 md:mb-20 md:max-w-none md:items-start md:text-left">
            <span className="mb-3 inline-block text-xs font-semibold uppercase tracking-[0.1em] text-pink-400 md:mb-5 md:text-sm md:tracking-widest" style={BODY}>Conheça quem ensina</span>
            <h2 className="mb-4 text-3xl leading-[1.12] text-balance sm:text-4xl md:mb-6 md:text-6xl md:leading-tight" style={HEADING}>
              Especialistas com nome, <span className="inline bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent italic md:block">vivência comprovada.</span>
            </h2>
            <p className="max-w-2xl text-[15px] leading-[1.4] text-white/80 md:text-lg md:leading-relaxed" style={BODY}>
              Cada instrutor tem atuação comprovada — não contratamos quem só leu sobre o assunto e resolveu ensinar.
            </p>
          </motion.div>

          <div className="md:hidden">
            <Swiper
              onSwiper={(swiper) => {
                instrutorSwiperRef.current = swiper;
              }}
              onSlideChange={(swiper) => {
                setInstrutorSlide(swiper.activeIndex);
              }}
              slidesPerView={1.08}
              spaceBetween={16}
              className="!overflow-visible"
            >
              {instrutores.map((inst, i) => (
                <SwiperSlide key={inst.nome} className="!h-auto">
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }}
                    onClick={() => setModalInstrutor(inst)}
                    className="group flex h-full cursor-pointer flex-col overflow-hidden rounded-3xl border border-white/8 bg-white/5">
                    <div className="relative h-72 overflow-hidden">
                      <img src={inst.foto} alt={inst.nome} loading="lazy" decoding="async" className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                      <div className={`absolute inset-0 bg-gradient-to-br ${inst.gradiente} opacity-15`} />
                      <div className="absolute bottom-0 left-0 p-5">
                        <div className={`mb-2 inline-flex items-center gap-1.5 rounded-full bg-gradient-to-r ${inst.gradiente} px-3 py-1 text-xs font-bold tracking-wide text-white`} style={BODY}>
                          {inst.especialidade}
                        </div>
                        <h3 className="text-2xl text-white" style={HEADING}>{inst.nome}</h3>
                      </div>
                    </div>
                    <div className="flex flex-1 flex-col gap-3 p-5">
                      <p className="line-clamp-4 text-sm leading-[1.7] text-white/72" style={BODY}>{inst.bio}</p>
                      <span className="block text-xs font-semibold leading-relaxed tracking-wide text-white/50" style={BODY}>{inst.badge}</span>
                      <div className="mt-auto flex w-full items-center justify-center gap-2 rounded-2xl border border-white/12 bg-white/8 px-4 py-3 text-sm font-semibold text-pink-300 transition-all group-hover:border-pink-500/25 group-hover:bg-white/12" style={BODY}>
                        Ver perfil <ChevronRight size={16} />
                      </div>
                    </div>
                  </motion.div>
                </SwiperSlide>
              ))}
            </Swiper>

            <div className="mt-6 flex justify-center gap-2">
              {instrutores.map((inst, i) => (
                <button
                  key={inst.nome}
                  type="button"
                  onClick={() => scrollToInstrutorCard(i)}
                  aria-label={`Ir para o instrutor ${inst.nome}`}
                  className={`h-2 rounded-full transition-all ${i === instrutorSlide ? 'w-6 bg-gradient-to-r from-pink-500 to-purple-500' : 'w-2 bg-white/20'}`}
                />
              ))}
            </div>
          </div>

          <div className="hidden gap-6 md:grid md:grid-cols-2 lg:grid-cols-4">
            {instrutores.map((inst, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                whileHover={{ y: -6 }}
                onClick={() => setModalInstrutor(inst)}
                className="rounded-3xl overflow-hidden bg-white/5 transition-all cursor-pointer group border border-white/8 flex h-full flex-col">
                {/* Photo */}
                <div className="relative h-72 overflow-hidden">
                  <img src={inst.foto} alt={inst.nome} loading="lazy" decoding="async" className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                  <div className={`absolute inset-0 bg-gradient-to-br ${inst.gradiente} opacity-0 group-hover:opacity-15 transition-opacity duration-300`} />
                  {/* Play hint */}
                  <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                    <div className="w-14 h-14 rounded-full bg-white/20 backdrop-blur border border-white/30 flex items-center justify-center">
                      <Play size={20} className="text-white ml-1" />
                    </div>
                  </div>
                  <div className="absolute bottom-0 left-0 p-5 z-10">
                    <div className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-gradient-to-r ${inst.gradiente} text-white text-xs font-bold tracking-wide mb-2`} style={BODY}>
                      {inst.especialidade}
                    </div>
                    <h3 className="text-2xl text-white" style={HEADING}>{inst.nome}</h3>
                  </div>
                </div>
                {/* Body */}
                <div className="p-6 flex flex-col gap-3 flex-1">
                  <p className="text-white/72 text-sm leading-[1.7] line-clamp-3" style={BODY}>{inst.bio}</p>
                  <span className="block min-h-[2.25rem] text-xs text-white/50 font-semibold tracking-wide leading-relaxed" style={BODY}>{inst.badge}</span>
                  <div
                    className="mt-1 w-full rounded-2xl bg-white/8 border border-white/12 px-4 py-3 flex items-center justify-center gap-2 text-sm font-semibold text-pink-300 group-hover:bg-white/12 group-hover:border-pink-500/25 transition-all"
                    style={BODY}
                  >
                    Ver perfil <ChevronRight size={16} />
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── BLOG ── */}
      <section id="blog" className="order-9 relative px-5 py-20 md:order-9 md:px-8 md:py-28">
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mb-10 text-center md:mb-20 md:text-left">
            <span className="mb-3 inline-block text-xs font-semibold uppercase tracking-[0.1em] text-pink-400 md:mb-5 md:text-sm md:tracking-widest" style={BODY}>Leia antes de decidir</span>
            <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
              <div className="mx-auto flex max-w-[85vw] flex-col items-center text-center md:mx-0 md:max-w-none md:items-start md:text-left">
                <h2 className="mb-4 text-3xl leading-[1.12] text-balance sm:text-4xl md:text-6xl md:leading-tight" style={HEADING}>
                  Experimente o conteúdo. <span className="inline bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent italic md:block">Sem pagar nada.</span>
                </h2>
                <p className="max-w-xl text-[15px] leading-[1.4] text-white/80 md:text-lg md:leading-relaxed" style={BODY}>
                  {blogPreviewSubtitle}
                </p>
              </div>
              <a
                href="/blog/"
                className="hidden items-center gap-2 text-sm font-semibold text-pink-400 hover:text-pink-300 transition-colors flex-shrink-0 md:flex"
                style={BODY}
              >
                Ver todos os artigos <ChevronRight size={15} />
              </a>
            </div>
          </motion.div>

          <div className="md:hidden">
            <Swiper
              onSwiper={(swiper) => {
                blogMobileSwiperRef.current = swiper;
              }}
              onSlideChange={(swiper) => {
                setBlogMobileSlide(swiper.activeIndex);
              }}
              slidesPerView={1.08}
              spaceBetween={16}
              className="!overflow-visible"
            >
              {blogPosts.slice(0, blogPreviewCount).map((post, i) => (
                <SwiperSlide key={post.id} className="!h-auto">
                  <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
                    className="group flex h-full min-h-[25rem] flex-col overflow-hidden rounded-3xl bg-white/5">
                    <div className="relative h-48 overflow-hidden">
                      <img src={post.imagem} alt={post.titulo} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                      <div className="absolute left-4 top-4 z-10 flex flex-wrap gap-1.5">
                        {post.categorias.slice(0, 2).map(cat => (
                          <span key={cat} className="rounded-full border border-white/15 bg-black/60 px-2.5 py-1 text-xs font-semibold text-white/85 backdrop-blur" style={BODY}>{cat}</span>
                        ))}
                      </div>
                    </div>
                    <div className="flex flex-1 flex-col p-5">
                      <h3 className="mb-2 line-clamp-2 min-h-[3.25rem] text-xl leading-snug tracking-wide transition-colors group-hover:text-pink-300" style={HEADING}>{post.titulo}</h3>
                      <p className="mb-4 flex-1 line-clamp-3 text-sm leading-[1.7] text-white/65" style={BODY}>{post.excerpt}</p>
                      <a
                        href={post.url || `/${post.slug}/`}
                        className="flex w-full items-center justify-center gap-2 rounded-2xl border border-white/12 bg-white/8 px-4 py-3 text-sm font-semibold text-pink-300 transition-all hover:border-pink-500/25 hover:bg-white/12"
                        style={BODY}
                      >
                        Ler artigo
                      </a>
                    </div>
                  </motion.div>
                </SwiperSlide>
              ))}

              <SwiperSlide className="!h-auto">
                <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.42 }}
                  className="group flex h-full min-h-[25rem] flex-col rounded-3xl border border-pink-500/20 p-5"
                  style={{ background: 'linear-gradient(145deg,rgba(255,0,110,0.07),rgba(114,9,183,0.10))' }}>
                  <div className="flex flex-1 flex-col items-center justify-center gap-5 text-center">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl transition-transform group-hover:scale-110" style={{ background: 'linear-gradient(135deg,#FF006E,#7209B7)', boxShadow: '0 0 24px rgba(255,0,110,0.3)' }}>
                      <LayoutList size={26} className="text-white" />
                    </div>
                    <div>
                      <p className="mb-2 text-xl font-bold leading-snug tracking-wide text-white" style={HEADING}>Ver todos os artigos</p>
                      <p className="text-sm tracking-wide text-white/45" style={BODY}>Conteúdo gratuito</p>
                    </div>
                  </div>
                  <a
                    href="/blog/"
                    className="flex w-full items-center justify-center gap-2 rounded-2xl border border-white/12 bg-white/8 px-4 py-3 text-sm font-semibold text-pink-300 transition-all hover:border-pink-500/25 hover:bg-white/12"
                    style={BODY}
                  >
                    Ver todos
                  </a>
                </motion.div>
              </SwiperSlide>
            </Swiper>

            <div className="mt-6 flex justify-center gap-2">
              {Array.from({ length: BLOG_TOTAL }).map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => scrollToMobileBlogCard(i)}
                  aria-label={`Ir para o slide ${i + 1}`}
                  className={`h-2 rounded-full transition-all ${i === blogMobileSlide ? 'w-6 bg-gradient-to-r from-pink-500 to-purple-500' : 'w-2 bg-white/20'}`}
                />
              ))}
            </div>

            <div className="mt-6 flex justify-center md:hidden">
              <a
                href="/blog/"
                className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/[0.04] px-5 py-3 text-sm font-semibold text-pink-300 transition-colors hover:bg-white/[0.07] hover:text-pink-200"
                style={BODY}
              >
                Ver todos os artigos <ChevronRight size={15} />
              </a>
            </div>
          </div>

          {/* Slider full-viewport: quebra o container max-w-7xl */}
          <div className="relative left-1/2 hidden w-screen -translate-x-1/2 select-none md:block">
            <Swiper
              onSwiper={(swiper) => {
                blogDesktopSwiperRef.current = swiper;
              }}
              onSlideChange={(swiper) => {
                setBlogDesktopSlideDirection(swiper.activeIndex >= blogPreviousDesktopSlideRef.current ? 'forward' : 'backward');
                blogPreviousDesktopSlideRef.current = swiper.activeIndex;
                setBlogDesktopSlide(swiper.activeIndex);
              }}
              slidesPerView="auto"
              spaceBetween={20}
              grabCursor
              watchSlidesProgress
              resistanceRatio={0.85}
              slidesOffsetBefore={blogSliderOffsets.before}
              slidesOffsetAfter={blogSliderOffsets.after}
              className="!overflow-visible py-8"
            >
              {blogPosts.slice(0, blogPreviewCount).map((post, i) => (
                <SwiperSlide key={post.id} className="!w-[300px]">
                  <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.06 }}
                    whileHover={{ y: -8, boxShadow: '0 24px 48px rgba(0,0,0,0.55)' }}
                    className="rounded-3xl overflow-hidden bg-white/5 group h-full min-h-[25.5rem] flex flex-col"
                    style={{ willChange: 'transform' }}
                  >
                    <div className="relative h-48 overflow-hidden">
                      <img src={post.imagem} alt={post.titulo} loading="lazy" decoding="async" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
                      <div className="absolute top-4 left-4 flex flex-wrap gap-1.5 z-10">
                        {post.categorias.slice(0, 2).map(cat => (
                          <span key={cat} className="px-2.5 py-1 rounded-full bg-black/60 backdrop-blur text-xs font-semibold text-white/85 border border-white/15" style={BODY}>{cat}</span>
                        ))}
                      </div>
                    </div>
                    <div className="p-6 flex flex-col flex-1">
                      <h3 className="text-xl mb-2 min-h-[3.5rem] line-clamp-2 leading-snug group-hover:text-pink-300 transition-colors tracking-wide" style={HEADING}>{post.titulo}</h3>
                      <p className="text-white/65 text-[15px] leading-[1.4] mb-4 line-clamp-2 tracking-wide flex-1" style={BODY}>{post.excerpt}</p>
                      <a
                        href={post.url || `/${post.slug}/`}
                        className="w-full rounded-2xl bg-white/8 border border-white/12 px-4 py-3 flex items-center justify-center gap-2 text-sm font-semibold text-pink-300 hover:bg-white/12 hover:border-pink-500/25 transition-all"
                        style={BODY}
                      >
                        Ler artigo
                      </a>
                    </div>
                  </motion.div>
                </SwiperSlide>
              ))}

              <SwiperSlide className="!w-[300px]">
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.45 }}
                  whileHover={{ y: -8, boxShadow: '0 24px 48px rgba(255,0,110,0.22)' }}
                  className="rounded-3xl flex h-full min-h-[25.5rem] flex-col p-6 group border border-pink-500/20 hover:border-pink-500/50 transition-colors"
                  style={{ background: 'linear-gradient(145deg,rgba(255,0,110,0.07),rgba(114,9,183,0.10))', willChange: 'transform' }}
                >
                  <div className="flex flex-1 flex-col items-center justify-center gap-5 text-center">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform"
                      style={{ background: 'linear-gradient(135deg,#FF006E,#7209B7)', boxShadow: '0 0 24px rgba(255,0,110,0.3)' }}>
                      <LayoutList size={26} className="text-white" />
                    </div>
                    <div className="text-center">
                      <p className="text-white font-bold text-xl leading-snug mb-2 tracking-wide" style={HEADING}>Ver todos os artigos</p>
                      <p className="text-white/45 text-sm tracking-wide" style={BODY}>Conteúdo gratuito</p>
                    </div>
                  </div>
                  <a
                    href="/blog/"
                    className="w-full rounded-2xl bg-white/8 border border-white/12 px-4 py-3 flex items-center justify-center gap-2 text-sm font-semibold text-pink-300 hover:bg-white/12 hover:border-pink-500/25 transition-all"
                    style={BODY}
                  >
                    Ver todos
                  </a>
                </motion.div>
              </SwiperSlide>
            </Swiper>

            {/* Dots */}
            <div className="flex justify-center items-center gap-3 mt-6 pb-2">
              {Array.from({ length: BLOG_TOTAL }).map((_, i) => (
                <button
                  key={i}
                  type="button"
                  onClick={() => scrollToDesktopBlogCard(i)}
                  aria-label={`Ir para o slide ${i + 1}`}
                  className={`relative h-2 overflow-hidden rounded-full transition-all duration-300 ${i === blogDesktopSlide ? 'w-6' : 'w-2 bg-white/20 hover:bg-white/45'}`}
                >
                  {i === blogDesktopSlide && (
                    <span
                      className={`absolute inset-0 bg-gradient-to-r from-pink-500 to-purple-500 transition-transform duration-300 ${blogDesktopSlideDirection === 'forward' ? 'origin-left scale-x-100' : 'origin-right scale-x-100'}`}
                    />
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* ── PREÇOS ── */}
      <section id="preco" className="order-3 relative px-5 py-16 md:order-10 md:px-8 md:py-28">
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="mx-auto mb-10 flex max-w-[85vw] flex-col items-center text-center md:mb-20 md:max-w-none">
            <span className="mb-3 inline-block text-xs font-semibold uppercase tracking-[0.1em] text-pink-400 md:mb-5 md:text-sm md:tracking-widest" style={BODY}>Escolha seu acesso</span>
            <h2 className="mb-4 text-3xl leading-[1.12] text-balance sm:text-4xl md:mb-6 md:text-6xl md:leading-tight" style={HEADING}>
              Uma assinatura. <span className="inline bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent italic md:block">Tudo incluído.</span>
            </h2>
            <p className="mx-auto max-w-xl text-[15px] leading-[1.4] text-white/80 md:text-lg md:leading-relaxed" style={BODY}>Sem surpresas, sem taxa de adesão. Transação segura e confidencial.</p>
          </motion.div>

          {/* GARANTIA DESTACADA */}
          <motion.div initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="mx-auto mb-8 flex max-w-2xl items-center gap-4 rounded-2xl border border-pink-500/30 px-5 py-4 md:mb-10 md:gap-5 md:px-8 md:py-5"
            style={{ background: 'linear-gradient(135deg, rgba(255,0,110,0.08) 0%, rgba(114,9,183,0.08) 100%)' }}>
            <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-r from-pink-500 to-purple-600 md:h-12 md:w-12">
              <Check size={22} className="text-white" />
            </div>
            <div>
              <div className="text-white font-bold mb-0.5" style={HEADING}>Garantia de 7 dias</div>
              <div className="text-white/65 text-sm" style={BODY}>Explore tudo. Se não for o que esperava, devolvemos 100% do valor — sem perguntas, sem burocracia.</div>
            </div>
          </motion.div>

          <div className="mx-auto mb-6 flex max-w-3xl gap-2 rounded-full border border-white/10 bg-white/[0.04] p-1.5 glass-soft md:hidden">
            {assinaturaPlanos.map((plano) => (
              <button
                key={plano.nome}
                type="button"
                onClick={() => setPlanoSelecionado(plano)}
                className={`flex-1 rounded-full px-3 py-3 text-xs font-semibold tracking-wide transition-all ${planoSelecionado.nome === plano.nome ? 'bg-gradient-to-r from-pink-500 to-purple-600 text-white shadow-lg shadow-pink-500/25' : 'text-white/68'}`}
                style={BODY}
              >
                <span className="flex flex-col items-center gap-1">
                  <span>{plano.nome}</span>
                 
                </span>
              </button>
            ))}
          </div>

          <div className="mx-auto max-w-xl md:hidden">
            <motion.div
              key={planoSelecionado.nome}
              initial={{ opacity: 0, y: 16 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.25, ease: 'easeOut' }}
              className="relative flex flex-col overflow-hidden rounded-3xl glass-soft"
              style={planoSelecionado.popular ? {
                background: 'linear-gradient(160deg, rgba(255,0,110,0.12) 0%, rgba(114,9,183,0.18) 100%)',
                border: '1px solid rgba(255,0,110,0.45)',
                boxShadow: '0 0 60px rgba(255,0,110,0.18), 0 24px 48px rgba(0,0,0,0.4)',
              } : {
                background: 'rgba(255,255,255,0.04)',
                border: '1px solid rgba(255,255,255,0.1)',
              }}
            >
              {planoSelecionado.popular && (
                <>
                  <div className="h-1 w-full flex-shrink-0" style={{ background: 'linear-gradient(90deg, #FF006E, #B5179E, #7209B7)' }} />
                  <div className="absolute left-1/2 top-4 z-10 -translate-x-1/2">
                    <span className="whitespace-nowrap rounded-full px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-white" style={{ background: 'linear-gradient(135deg, #FF006E, #7209B7)', boxShadow: '0 4px 16px rgba(255,0,110,0.4)', ...BODY }}>
                      Opção recomendada
                    </span>
                  </div>
                </>
              )}

              <div className={`flex flex-1 flex-col p-6 ${planoSelecionado.popular ? 'pt-14' : ''}`}>
                <div className="mb-7">
                  <div className="mb-1.5 text-2xl font-bold tracking-tight" style={HEADING}>{planoSelecionado.nome}</div>
                  <div className="text-sm tracking-wide text-white/55" style={BODY}>{planoSelecionado.tagline}</div>
                </div>

                <div className="mb-1.5 flex items-baseline gap-1.5">
                  <span className="text-base font-semibold text-white/55" style={BODY}>R$</span>
                  <span className={`text-5xl leading-none font-bold tracking-tight ${planoSelecionado.popular ? 'bg-gradient-to-r from-pink-300 to-fuchsia-300 bg-clip-text text-transparent' : 'text-white'}`} style={HEADING}>
                    {planoSelecionado.preco}
                  </span>
                  <span className="text-xl font-semibold text-white/55" style={BODY}>,{planoSelecionado.centavos}</span>
                </div>
                <div className="mb-8 text-sm leading-relaxed tracking-wide text-white/45" style={BODY}>{planoSelecionado.periodo}</div>

                <ul className="mb-8 flex-1 space-y-4">
                  {planoSelecionado.recursos.map((r, ri) => (
                    <li key={ri} className="flex items-start gap-3 text-sm tracking-wide text-white/80" style={BODY}>
                      <Check size={16} className="mt-0.5 flex-shrink-0 text-pink-500" />
                      <span className="leading-relaxed">{r}</span>
                    </li>
                  ))}
                </ul>

                {hasText(planoSelecionado.link) ? (
                  <motion.a
                    href={planoSelecionado.link}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                    className="w-full rounded-2xl py-4 text-base font-bold tracking-wide transition-all text-center"
                    style={planoSelecionado.popular ? {
                      background: 'linear-gradient(135deg, #FF006E, #B5179E)',
                      color: '#fff',
                      boxShadow: '0 8px 32px rgba(255,0,110,0.45)',
                      ...BODY,
                    } : {
                      background: 'rgba(255,255,255,0.10)',
                      border: '1px solid rgba(255,255,255,0.25)',
                      color: 'rgba(255,255,255,0.90)',
                      ...BODY,
                    }}
                  >
                    {planoSelecionado.cta}
                  </motion.a>
                ) : (
                  <motion.button
                    type="button"
                    disabled
                    className="w-full rounded-2xl py-4 text-base font-bold tracking-wide transition-all opacity-45 cursor-not-allowed"
                    style={planoSelecionado.popular ? {
                      background: 'linear-gradient(135deg, #FF006E, #B5179E)',
                      color: '#fff',
                      boxShadow: '0 8px 32px rgba(255,0,110,0.45)',
                      ...BODY,
                    } : {
                      background: 'rgba(255,255,255,0.10)',
                      border: '1px solid rgba(255,255,255,0.25)',
                      color: 'rgba(255,255,255,0.90)',
                      ...BODY,
                    }}
                  >
                    {planoSelecionado.cta}
                  </motion.button>
                )}
              </div>
            </motion.div>
          </div>

          <div className="mx-auto hidden max-w-5xl grid-cols-1 gap-5 md:grid md:grid-cols-3">
            {assinaturaPlanos.map((plano, i) => (
              <motion.div key={i}
                initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                whileHover={{ y: -10, scale: 1.02 }}
                className="relative flex flex-col rounded-3xl glass-soft overflow-hidden"
                style={plano.popular ? {
                  background: 'linear-gradient(160deg, rgba(255,0,110,0.12) 0%, rgba(114,9,183,0.18) 100%)',
                  border: '1px solid rgba(255,0,110,0.45)',
                  boxShadow: '0 0 60px rgba(255,0,110,0.18), 0 24px 48px rgba(0,0,0,0.4)',
                } : {
                  background: 'rgba(255,255,255,0.04)',
                  border: '1px solid rgba(255,255,255,0.1)',
                }}
              >
                {/* Top accent bar — só no popular */}
                {plano.popular && (
                  <div className="h-1 w-full flex-shrink-0" style={{ background: 'linear-gradient(90deg, #FF006E, #B5179E, #7209B7)' }} />
                )}

                {/* Badge Recomendado */}
                {plano.popular && (
                  <div className="absolute top-4 left-1/2 -translate-x-1/2 z-10">
                    <span className="px-4 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase text-white whitespace-nowrap"
                      style={{ background: 'linear-gradient(135deg, #FF006E, #7209B7)', boxShadow: '0 4px 16px rgba(255,0,110,0.4)', ...BODY }}>
                      Opção recomendada
                    </span>
                  </div>
                )}

                <div className={`p-6 md:p-9 flex flex-col flex-1 ${plano.popular ? 'pt-14' : ''}`}>
                  {/* Name + tagline */}
                  <div className="mb-8">
                    <div className="text-2xl font-bold mb-1.5 tracking-tight" style={HEADING}>{plano.nome}</div>
                    <div className="text-sm text-white/55 tracking-wide" style={BODY}>{plano.tagline}</div>
                  </div>

                  {/* Price */}
                  <div className="flex items-baseline gap-1.5 mb-1.5">
                    <span className="text-base text-white/55 font-semibold" style={BODY}>R$</span>
                    <span className={`text-5xl md:text-6xl leading-none font-bold tracking-tight ${plano.popular ? 'bg-gradient-to-r from-pink-300 to-fuchsia-300 bg-clip-text text-transparent' : 'text-white'}`} style={HEADING}>
                      {plano.preco}
                    </span>
                    <span className="text-xl text-white/55 font-semibold" style={BODY}>,{plano.centavos}</span>
                  </div>
                  <div className="text-sm text-white/45 mb-9 tracking-wide leading-relaxed" style={BODY}>{plano.periodo}</div>

                  {/* Resources */}
                  <ul className="space-y-4 mb-10 flex-1">
                    {plano.recursos.map((r, ri) => (
                      <li key={ri} className="flex items-start gap-3 text-white/80 text-sm tracking-wide" style={BODY}>
                        <Check size={16} className="text-pink-500 flex-shrink-0 mt-0.5" />
                        <span className="leading-relaxed">{r}</span>
                      </li>
                    ))}
                  </ul>

                  {/* CTA */}
                  {hasText(plano.link) ? (
                    <motion.a
                      href={plano.link}
                      target="_blank"
                      rel="noopener noreferrer nofollow"
                      whileHover={{ scale: 1.03 }}
                      whileTap={{ scale: 0.97 }}
                      className="w-full py-4 rounded-2xl font-bold text-base tracking-wide transition-all text-center"
                      style={plano.popular ? {
                        background: 'linear-gradient(135deg, #FF006E, #B5179E)',
                        color: '#fff',
                        boxShadow: '0 8px 32px rgba(255,0,110,0.45)',
                        ...BODY,
                      } : {
                        background: 'rgba(255,255,255,0.10)',
                        border: '1px solid rgba(255,255,255,0.25)',
                        color: 'rgba(255,255,255,0.90)',
                        ...BODY,
                      }}
                    >
                      {plano.cta}
                    </motion.a>
                  ) : (
                    <motion.button
                      type="button"
                      disabled
                      className="w-full py-4 rounded-2xl font-bold text-base tracking-wide transition-all opacity-45 cursor-not-allowed"
                      style={plano.popular ? {
                        background: 'linear-gradient(135deg, #FF006E, #B5179E)',
                        color: '#fff',
                        boxShadow: '0 8px 32px rgba(255,0,110,0.45)',
                        ...BODY,
                      } : {
                        background: 'rgba(255,255,255,0.10)',
                        border: '1px solid rgba(255,255,255,0.25)',
                        color: 'rgba(255,255,255,0.90)',
                        ...BODY,
                      }}
                    >
                      {plano.cta}
                    </motion.button>
                  )}
                </div>
              </motion.div>
            ))}
          </div>

          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
            className="text-center text-white/50 mt-10 flex items-center justify-center gap-2 text-sm tracking-wide" style={BODY}>
            <Lock size={13} /> Esta transação é segura e confidencial, processada com o mais alto padrão de segurança.
          </motion.p>
        </div>
      </section>

      {/* ── CTA FINAL ── */}
      <section className="order-10 relative overflow-hidden px-5 py-24 md:px-8 md:py-36">
        <div className="max-w-4xl mx-auto text-center relative z-10">
          <h2
            className="mx-auto mb-6 max-w-[90vw] text-3xl leading-[1.16] text-balance sm:text-4xl md:mb-8 md:max-w-none md:text-7xl md:leading-[1.15]"
            style={{ ...HEADING, opacity: 1, transform: 'none' }}
          >
            Você já sabe que quer aprender.<span
              className="inline bg-gradient-to-r from-pink-500 to-purple-500 bg-clip-text text-transparent italic md:block"
              style={{ paddingBottom: '10px' }}
            > Agora é a hora.</span>
          </h2>
          <motion.p initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
            className="mx-auto mb-10 max-w-2xl text-base leading-[1.8] text-white/82 md:mb-14 md:text-lg" style={BODY}>
            {finalCtaData.subtitle}
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}
            className="flex flex-col sm:flex-row gap-5 justify-center mb-8">
            {hasText(finalCtaData.link) ? (
              <motion.a
                href={finalCtaData.link}
                target="_blank"
                rel="noopener noreferrer nofollow"
                whileHover={{ scale: 1.05, boxShadow: '0 0 50px rgba(236,72,153,0.6)' }}
                whileTap={{ scale: 0.95 }}
                className="px-10 py-5 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 font-bold text-base tracking-wide shadow-2xl shadow-pink-500/40 text-center"
                style={BODY}
              >
                {finalCtaData.button}
              </motion.a>
            ) : (
              <motion.button
                type="button"
                whileHover={{ scale: 1.05, boxShadow: '0 0 50px rgba(236,72,153,0.6)' }}
                whileTap={{ scale: 0.95 }}
                onClick={() => scrollParaSecao('preco')}
                className="px-10 py-5 rounded-full bg-gradient-to-r from-pink-500 to-purple-600 font-bold text-base tracking-wide shadow-2xl shadow-pink-500/40"
                style={BODY}
              >
                {finalCtaData.button}
              </motion.button>
            )}
          </motion.div>
          <p className="text-sm text-white/50 tracking-wide" style={BODY}>{finalCtaData.disclaimer}</p>
        </div>
      </section>

      </main>

      {/* ── FOOTER ── */}
      <SiteFooter featuredPosts={landingData.footerFeaturedPosts} />

      {/* ── INSTRUCTOR MODAL ── */}
      <AnimatePresence>
        {modalInstrutor && (
          <InstructorModal instrutor={modalInstrutor} onClose={() => setModalInstrutor(null)} />
        )}
      </AnimatePresence>
    </div>
  );
}
